package com.raouf.mehrguard.web.i18n

internal val JapaneseStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "Kotlin Multiplatform QRishingディテクター",
    WebStringKey.MenuMain to "メインメニュー",
    WebStringKey.MenuSecurity to "セキュリティ",
    WebStringKey.MenuSystem to "システム",
    WebStringKey.NavDashboard to "ダッシュボード",
    WebStringKey.NavScanMonitor to "スキャンモニター",
    WebStringKey.NavScanHistory to "スキャン履歴",
    WebStringKey.NavTrustCentre to "トラストセンター",
    WebStringKey.NavReports to "レポート",
    WebStringKey.NavTraining to "トレーニング",
    WebStringKey.NavSettings to "設定",
    WebStringKey.QuickActions to "クイックアクション",
    WebStringKey.HeroTagline to "安全。オフライン。",
    WebStringKey.HeroTagline2 to "説明可能な防御。",
    WebStringKey.HeroDescription to "Mehr Guardはお使いのハードウェア上で直接潜在的な脅威を分析します。",
    WebStringKey.StartScan to "新規スキャン開始",
    WebStringKey.ImportImage to "画像インポート",
    WebStringKey.ScanQrCode to "QRコードをスキャン",
    WebStringKey.SystemHealth to "システム状態",
    WebStringKey.ThreatDatabase to "脅威データベース",
    WebStringKey.Current to "現在",
    WebStringKey.Active to "アクティブ",
    WebStringKey.Threats to "脅威",
    WebStringKey.SafeScans to "安全なスキャン",
    WebStringKey.EngineActive to "エンジン稼働中",
    WebStringKey.EnterpriseProtection to "企業保護有効",
    WebStringKey.SystemOptimal to "システム最適",
    WebStringKey.EngineStatus to "エンジン v2.4 • 2時間前に更新",
    WebStringKey.ThreatsBlocked to "ブロックされた脅威",
    WebStringKey.AllSystemsOperational to "全システム稼働中",
    WebStringKey.SectionOverview to "概要",
    WebStringKey.SectionSecurity to "セキュリティ",
    WebStringKey.SectionTraining to "トレーニング",
    WebStringKey.SectionReports to "レポート",
    WebStringKey.OfflineReady to "オフライン準備完了",
    WebStringKey.OfflineDescription to "ローカルデータベース v2.4.1 がアクティブです。",
    WebStringKey.TrustCentreTitle to "トラストセンター",
    WebStringKey.OfflineGuarantee to "厳密なオフライン保証",
    WebStringKey.OfflineGuaranteeDesc to "Mehr Guard分析はすべてデバイスのニューラルエンジン上で実行されます。",
    WebStringKey.ThreatSensitivity to "脅威の感度",
    WebStringKey.ResetConfirm to "この操作により、すべてのトラストセンター設定がデフォルトにリセットされます。",
    WebStringKey.ThreatMonitor to "脅威モニター",
    WebStringKey.ThreatMonitorDesc to "リアルタイムの脅威を表示し、セキュリティチェックを実行します。",
    WebStringKey.TrustCentreDesc to "プライバシーと脅威感度の設定。",
    WebStringKey.ExportReport to "レポートをエクスポート",
    WebStringKey.ExportReportDesc to "PDFまたはJSONのセキュリティレポートを生成します。",
    WebStringKey.Analyze to "分析",
    WebStringKey.HeuristicEngine to "ヒューリスティックエンジン",
    WebStringKey.HighPerformanceEngine to "高性能エンジン",
    WebStringKey.RecentScans to "最近のスキャン",
    WebStringKey.ViewFullHistory to "完全な履歴を表示",
    WebStringKey.Status to "ステータス",
    WebStringKey.Source to "ソース",
    WebStringKey.Details to "詳細",
    WebStringKey.Time to "時間",
    WebStringKey.Version to "バージョン",
    WebStringKey.LastUpdate to "最終更新",
    WebStringKey.Signatures to "シグネチャ",
    WebStringKey.CheckForUpdates to "更新を確認",
    WebStringKey.FeatureOfflineTitle to "オフラインファーストアーキテクチャ",
    WebStringKey.FeatureOfflineDesc to "完全な分析はローカルで実行されます。",
    WebStringKey.FeatureExplainableTitle to "説明可能なセキュリティ",
    WebStringKey.FeatureExplainableDesc to "単なる「ブロック」ではありません。URLパラメータの詳細な分析を提供します。",
    WebStringKey.FeaturePerformanceDesc to "デスクトップ環境向けに最適化されています。5ms未満でスキャンを処理します。",
    WebStringKey.TrainingCentre to "トレーニングセンター",
    WebStringKey.LearnHomograph to "高度なQRホモグラフ攻撃を特定する方法を学びます。",
    WebStringKey.BeatTheBotAction to "ボットを倒す →",
    WebStringKey.NoScansYet to "スキャンはまだありません。新しいスキャンを開始してください。",
    WebStringKey.VerdictSafe to "安全",
    WebStringKey.VerdictPhish to "フィッシング",
    WebStringKey.VerdictWarn to "警告",
    WebStringKey.ScoreLabel to "スコア：",
    WebStringKey.ActiveScanner to "アクティブスキャナー",
    WebStringKey.OfflineMode to "オフラインモード",
    WebStringKey.LiveFeedDisconnected to "ライブフィード切断",
    WebStringKey.CameraAccessRequired to "カメラアクセスが必要",
    WebStringKey.CameraAccessDescription to "QRコード画像をここにドラッグ＆ドロップしてください。",
    WebStringKey.EnableCamera to "カメラを有効にする",
    WebStringKey.Scanning to "スキャン中...",
    WebStringKey.ScanHint to "固定してください。5ms未満でオフライン分析。",
    WebStringKey.Torch to "ライト",
    WebStringKey.Gallery to "ギャラリー",
    WebStringKey.PasteUrl to "URLを貼り付け",
    WebStringKey.PasteUrlTitle to "分析するURLを貼り付け",
    WebStringKey.AnalyzeUrl to "URLを分析",
    WebStringKey.SystemStatus to "システムステータス",
    WebStringKey.PhishingEngine to "フィッシングエンジン",
    WebStringKey.Ready to "準備完了",
    WebStringKey.LocalDb to "ローカルDB",
    WebStringKey.Latency to "レイテンシ",
    WebStringKey.ViewAll to "すべて表示",
    WebStringKey.BreadcrumbHome to "ホーム",
    WebStringKey.BreadcrumbScans to "スキャン",
    WebStringKey.OfflineProtection to "オフライン保護",
    WebStringKey.VerdictHighRisk to "高リスク検出",
    WebStringKey.VerdictDangerous to "危険",
    WebStringKey.VerdictDangerousDesc to "スキャンされたQRコードには悪意のある指標が含まれています。",
    WebStringKey.ThreatConfidence to "脅威の信頼度",
    WebStringKey.FlagPhishing to "フィッシングの試み",
    WebStringKey.FlagObfuscated to "難読化スクリプト",
    WebStringKey.FlagHomograph to "ホモグラフ攻撃",
    WebStringKey.ClearHistory to "すべてクリア",
    WebStringKey.SectionAttackBreakdown to "攻撃の内訳",
    WebStringKey.AttackHomographTitle to "ホモグラフ / IDN攻撃",
    WebStringKey.AttackHomographDesc to "ラテンアルファベットを模倣したキリル文字が検出されました。",
    WebStringKey.AttackVisualLabel to "視覚的外観",
    WebStringKey.AttackPunycodeLabel to "実際のPunycode",
    WebStringKey.AttackHomographExplain to "ドメインはラテン語の代わりにキリル文字を使用しています。",
    WebStringKey.AttackRedirectTitle to "不審なリダイレクトチェーン",
    WebStringKey.AttackRedirectDesc to "既知のURL短縮サービスを含む3つのホップが検出されました。",
    WebStringKey.RedirectStart to "QRコードスキャン",
    WebStringKey.RedirectHop to "中間ホップ",
    WebStringKey.RedirectFinal to "最終目的地",
    WebStringKey.AttackJsTitle to "難読化されたJavaScript",
    WebStringKey.AttackJsDesc to "URLパラメータに高エントロピー文字列が検出されました。",
    WebStringKey.SectionActions to "推奨されるアクション",
    WebStringKey.ActionBlock to "ブロックして報告",
    WebStringKey.ActionBlockDesc to "アクセスを防止し、管理者に通知します。",
    WebStringKey.ActionQuarantine to "サンドボックスに隔離",
    WebStringKey.ActionQuarantineDesc to "分析のために安全に開きます。",
    WebStringKey.Expected to "期待値: ",
    WebStringKey.Detected to "検出: ",
    WebStringKey.ExplainableSecurity to "説明可能なセキュリティ",
    WebStringKey.UrlBreakdown to "URL分析",
    WebStringKey.FullUrl to "完全なURL",
    WebStringKey.OpenInBrowser to "ブラウザで開く（リスクあり）",
    WebStringKey.OpenWarning to "このURLをブラウザで開くと、セキュリティリスクにさらされる可能性があります。",
    WebStringKey.RestrictedMode to "制限モード",
    WebStringKey.RestrictedDesc to "このURLは潜在的に有害とマークされています。",
    WebStringKey.DangerousWarning to "このURLは潜在的に有害です。続行してもよろしいですか？",
    WebStringKey.CopyUrl to "URLをコピー",
    WebStringKey.Share to "共有",
    WebStringKey.Dismiss to "閉じる",
    WebStringKey.ReasonDomainAge to "ドメインの年齢が24時間未満です。",
    WebStringKey.ReasonSignatures to "ローカルフィッシングDBの3つのシグネチャと一致しました。",
    WebStringKey.ReasonAsn to "ターゲットIPは高リスクASNに配置されています。",
    WebStringKey.SectionMeta to "スキャンメタデータ",
    WebStringKey.MetaTime to "スキャン時間",
    WebStringKey.MetaSource to "ソース",
    WebStringKey.MetaEngine to "エンジン",
    WebStringKey.MetaOfflineGuaranteeLabel to "オフライン保証：",
    WebStringKey.MetaOfflineGuaranteeDesc to "この画像はお使いのデバイスでローカルに分析されました。",
    
    WebStringKey.ScanComplete to "スキャン完了",
    WebStringKey.Loading to "読み込み中...",
    WebStringKey.AnalyzedOffline to "5ms未満でオフライン分析",
    WebStringKey.NoDataLeaves to "データはデバイスを離れません",
    WebStringKey.ActiveProtection to "アクティブ保護",
    WebStringKey.ConfidenceScore to "信頼スコア",
    WebStringKey.Analyzing to "分析中...",
    WebStringKey.ProcessingResults to "スキャン結果を処理中...",
    WebStringKey.RiskAssessment to "リスク評価",
    WebStringKey.AnalysisTime to "分析時間",
    WebStringKey.Heuristics to "ヒューリスティック",
    WebStringKey.TopAnalysisFactors to "主要分析要因",
    WebStringKey.Pass to "合格",
    WebStringKey.Info to "情報",
    WebStringKey.Clean to "クリーン",
    WebStringKey.ValidSslCertificate to "有効なSSL証明書",
    WebStringKey.SslCertificateDesc to "DigiCert Incによって発行された証明書",
    WebStringKey.EstablishedDomain to "確立されたドメイン",
    WebStringKey.EstablishedDomainDesc to "ドメインは5年以上前に登録",
    WebStringKey.BlacklistStatus to "ブラックリスト状態",
    WebStringKey.BlacklistStatusDesc to "52のローカル脅威DBで見つかりません",
    WebStringKey.BackToDashboard to "ダッシュボードに戻る",
    WebStringKey.ShareReport to "レポートを共有",
    WebStringKey.CopyLink to "リンクをコピー",
    WebStringKey.LinkCopied to "リンクをクリップボードにコピーしました!",
    WebStringKey.BeatTheBot to "ボットを倒す",
    WebStringKey.BeatTheBotDesc to "オフラインAIに挑戦",
    WebStringKey.SessionId to "セッションID",
    WebStringKey.EndSession to "セッション終了",
    WebStringKey.Round to "ラウンド",
    WebStringKey.BrowserPreview to "ブラウザプレビュー",
    WebStringKey.MakeDecision to "判断してください",
    WebStringKey.Phishing to "フィッシング",
    WebStringKey.Legitimate to "正規",
    WebStringKey.LiveHint to "ライブヒント",
    WebStringKey.LiveScoreboard to "ライブスコアボード",
    WebStringKey.VsMode to "VSモード",
    WebStringKey.You to "あなた",
    WebStringKey.Points to "ポイント",
    WebStringKey.Streak to "連続",
    WebStringKey.Accuracy to "精度",
    WebStringKey.MehrGuardBot to "Mehr Guardボット",
    WebStringKey.Confidence to "信頼度",
    WebStringKey.RoundAnalysis to "ラウンド分析",
    WebStringKey.Analysis to "分析",
    WebStringKey.CorrectDecision to "正しい判断!",
    WebStringKey.IdentifiedSafe to "安全なURLを正しく識別しました",
    WebStringKey.AiNeuralAnalysis to "AIニューラル分析",
    WebStringKey.WhyBotFlagged to "ボットがフラグした理由",
    WebStringKey.EducationalNote to "教育ノート",
    WebStringKey.Correct to "正解!",
    WebStringKey.SpottedPhishing to "フィッシングURLを正しく検出しました",
    WebStringKey.Response to "レスポンス",
    WebStringKey.NextRound to "次のラウンド",
    WebStringKey.GameOver to "ゲームオーバー!",
    WebStringKey.FinalResults to "最終結果",
    WebStringKey.YourScore to "あなたのスコア",
    WebStringKey.BotScore to "ボットスコア",
    WebStringKey.BestStreak to "ベストストリーク",
    WebStringKey.PlayAgain to "もう一度プレイ",
    WebStringKey.ReturnToDashboard to "ダッシュボードに戻る",
    WebStringKey.ExportSecurityReport to "セキュリティレポートをエクスポート",
    WebStringKey.GenerateReport to "完全なセキュリティレポートを生成",
    WebStringKey.ReportFormat to "レポート形式",
    WebStringKey.HumanReadable to "人間が読めるレポート",
    WebStringKey.HumanReadableDesc to "視覚分析付きPDF",
    WebStringKey.MachineReadable to "機械可読データ",
    WebStringKey.MachineReadableDesc to "SIEM統合用JSON形式",
    WebStringKey.DateRange to "日付範囲",
    WebStringKey.Last7Days to "過去7日間",
    WebStringKey.Last30Days to "過去30日間",
    WebStringKey.Last90Days to "過去90日間",
    WebStringKey.AllTime to "全期間",
    WebStringKey.CustomRange to "カスタム範囲",
    WebStringKey.ReportSections to "レポートセクション",
    WebStringKey.ExecutiveSummary to "概要",
    WebStringKey.ThreatBreakdown to "脅威の内訳",
    WebStringKey.ScanTimeline to "スキャンタイムライン",
    WebStringKey.SafeUrlList to "安全なURLリスト",
    WebStringKey.GenerateExport to "レポートをエクスポート",
    WebStringKey.Success to "成功!",
    WebStringKey.Error to "エラー",
    WebStringKey.Warning to "警告",
    WebStringKey.CopiedToClipboard to "クリップボードにコピー",
    WebStringKey.Cancel to "キャンセル",
    WebStringKey.Confirm to "確認",
    WebStringKey.Save to "保存",
    WebStringKey.Delete to "削除",
    WebStringKey.Edit to "編集",
    WebStringKey.Close to "閉じる",
    WebStringKey.Back to "戻る",
    WebStringKey.Next to "次へ",
    WebStringKey.Previous to "前へ",
    WebStringKey.Submit to "送信",
    WebStringKey.Reset to "リセット",
    WebStringKey.Clear to "クリア",
    WebStringKey.Search to "検索",
    WebStringKey.Filter to "フィルター",
    WebStringKey.Sort to "並べ替え",
    WebStringKey.ToggleMenu to "メニュー切替",
    WebStringKey.ToggleTheme to "テーマ切替",
    WebStringKey.Notifications to "通知",
    WebStringKey.Help to "ヘルプ",
    WebStringKey.Profile to "プロフィール",
    WebStringKey.ToggleLightDarkMode to "ライト/ダークモード切替",
    WebStringKey.UrlInputPlaceholder to "分析するURLを貼り付け",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    WebStringKey.Scan to "スキャン",
    WebStringKey.Result to "結果",
    WebStringKey.ReportGeneration to "レポート生成",
    WebStringKey.ReportGenerationDesc to "形式を設定してダウンロード",
    WebStringKey.OfflineSecurity to "オフラインセキュリティ",
    WebStringKey.OfflineSecurityDesc to "データはこのデバイスを離れません",
    WebStringKey.ChooseFormat to "形式を選択",
    WebStringKey.PdfFormatDesc to "PDF形式。共有に最適",
    WebStringKey.JsonFormatDesc to "JSON形式。SIEM統合に最適",
    WebStringKey.Copy to "コピー",
    WebStringKey.LivePreview to "ライブプレビュー",
    WebStringKey.ReadOnly to "読み取り専用",
    WebStringKey.ThreatAnalysisReport to "脅威分析レポート",
    WebStringKey.Verdict to "判定",
    WebStringKey.RiskScore to "リスクスコア",
    WebStringKey.TargetUrl to "ターゲットURL",
    WebStringKey.AnalysisSummaryLabel to "分析概要",
    WebStringKey.TechnicalIndicators to "技術指標",
    WebStringKey.ExportInfoNote to "すべての脅威ベクトル含む",
    WebStringKey.AllowList to "許可リスト",
    WebStringKey.BlockList to "ブロックリスト",
    WebStringKey.AddDomain to "ドメイン追加",
    WebStringKey.RemoveDomain to "ドメイン削除",
    WebStringKey.TrustedDomains to "信頼されたドメイン",
    WebStringKey.BlockedDomains to "ブロックされたドメイン",
    WebStringKey.DomainPlaceholder to "ドメインを入力",
    WebStringKey.Safe to "安全",
    WebStringKey.TimeAgo to "前",
    WebStringKey.MinutesAgo to "分前",
    WebStringKey.HoursAgo to "時間前",
    WebStringKey.Critical to "重大",
    WebStringKey.Warn to "警告",
    WebStringKey.PhishingDetectionSensitivity to "フィッシング検出感度",
    WebStringKey.SensitivityDescription to "ヒューリスティック閾値を調整",
    WebStringKey.SensitivityLow to "低",
    WebStringKey.SensitivityBalanced to "バランス",
    WebStringKey.SensitivityParanoia to "パラノイア",
    WebStringKey.BalancedModeRecommended to "バランスモード(推奨)",
    WebStringKey.BalancedModeDesc to "悪意のあるパターンをスキャン",
    WebStringKey.LowSensitivityMode to "低感度モード",
    WebStringKey.LowSensitivityModeDesc to "脅威データベースから既知の悪意のあるURLのみをブロックします。誤検知は最小限ですが、新しい攻撃を見逃す可能性があります。",
    WebStringKey.ParanoiaMode to "パラノイアモード",
    WebStringKey.ParanoiaModeDesc to "最大の保護。新規登録ドメイン、一般的でないTLD、潜在的なエンコーディングトリックを含むすべての疑わしいパターンをブロックします。",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guardはローカルのヒューリスティック分析エンジンを使用しています。スキャン中に画像データ、URL文字列、またはメタデータがこのデバイスから送信されることはありません。あなたのプライバシーは数学的に保証されています。",
    WebStringKey.SignalBrandImpersonation to "潜在的なブランドなりすましを検出",
    WebStringKey.SignalCredentialParams to "URLに認証関連パラメータ",
    WebStringKey.SignalEncodedPayload to "クエリパラメータでエンコードされたデータを検出",
    WebStringKey.SignalExcessiveSubdomains to "過度のサブドメイン深度（{count}レベル）",
    WebStringKey.SignalHighEntropyHost to "ドメイン名の高いランダム性",
    WebStringKey.SignalHomographAttack to "ドメインにホモグラフ/紛らわしい文字が含まれています",
    WebStringKey.SignalHttpNotHttps to "安全でないHTTPプロトコルを使用",
    WebStringKey.SignalIpAddressHost to "ホストがドメインではなくIPアドレス",
    WebStringKey.SignalLongUrl to "異常に長いURL（{length}文字）",
    WebStringKey.SignalLongUrlMarketing to "異常に長いURL（{length}文字）- マーケティングパラメータを含む",
    WebStringKey.SignalNewlyRegisteredDomain to "新規登録ドメインを検出",
    WebStringKey.SignalNonStandardPort to "非標準ポート: {port}",
    WebStringKey.SignalNumericSubdomain to "数字のみのサブドメインを検出",
    WebStringKey.SignalSuspiciousPathKeywords to "パスに疑わしいキーワード（{count}件発見）",
    WebStringKey.SignalSuspiciousTld to "疑わしいTLD: {tld}",
    WebStringKey.SignalUrlShortener to "URL短縮サービスを使用",
    WebStringKey.SecureEnvironment to "安全な環境",
    WebStringKey.LearnLocalArchitecture to "ローカルアーキテクチャについて",
    WebStringKey.NoCustomDomainsBlocked to "ブロックされたカスタムドメインなし",
    WebStringKey.AddManually to "手動で追加",
    WebStringKey.AddedDaysAgo to "2日前に追加",
    WebStringKey.AddedWeekAgo to "1週間前に追加",
    WebStringKey.PrivacyControls to "プライバシー管理",
    WebStringKey.StrictOfflineMode to "厳格オフラインモード",
    WebStringKey.DisableExternalPreviews to "外部リンクプレビューを無効",
    WebStringKey.AnonymousTelemetry to "匿名テレメトリ",
    WebStringKey.ShareDetectionStats to "検出統計を共有",
    WebStringKey.AutoCopySafeLinks to "安全なリンクを自動コピー",
    WebStringKey.CopyTrustedUrls to "信頼されたURLをコピー",
    WebStringKey.AboutMehrGuard to "Mehr Guardについて",
    WebStringKey.OpenSourceLicenses to "オープンソースライセンス",
    WebStringKey.PrivacyPolicy to "プライバシーポリシー",
    WebStringKey.Acknowledgements to "謝辞",
    WebStringKey.ResetAllSettings to "すべての設定をリセット",
    WebStringKey.AddToAllowlist to "許可リストに追加",
    WebStringKey.AddToBlocklist to "ブロックリストに追加",
    WebStringKey.AnalysedOfflineTitle to "オフライン分析",
    WebStringKey.YourDataStaysOnDevice to "データはデバイスに残ります",
    WebStringKey.OnboardingHeroDesc to "安全なオンデバイス分析",
    WebStringKey.OnDeviceAnalysis to "オンデバイス分析",
    WebStringKey.OnDeviceAnalysisDesc to "すべての脅威検出はローカル実行",
    WebStringKey.NoCloudLogs to "クラウドログなし",
    WebStringKey.NoCloudLogsDesc to "送信テレメトリを無効化",
    WebStringKey.OnDeviceDB to "オンデバイスDB",
    WebStringKey.OnDeviceDBDesc to "完全な脅威シグネチャDB",
    WebStringKey.DataLifecycleVerification to "データライフサイクル検証",
    WebStringKey.SecurityAuditPass to "セキュリティ監査: 合格",
    WebStringKey.Copyright to "© 2024 Mehr Guard Security Inc.",
    WebStringKey.Support to "サポート",
    WebStringKey.Terms to "利用規約",
    WebStringKey.SystemsOperational to "システム稼働中",
    WebStringKey.SystemSecure to "システム安全",
    WebStringKey.VersionStatus to "v2.4.1 • システム安全",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2024.12.19",
    WebStringKey.VerifiedBy to "Mehr Guard Enterprise認証",
    WebStringKey.SampleUserName to "田中太郎",
    WebStringKey.SampleUserRole to "セキュリティアナリスト",
    WebStringKey.DetailLabel to "詳細ラベル",
    WebStringKey.DetailValue to "詳細値",
    WebStringKey.Suspicious to "疑わしい",
    WebStringKey.IncorrectDecision to "不正解",
    WebStringKey.WrongAnswer to "残念!間違いでした",
    WebStringKey.ResponseTime to "応答時間",
    WebStringKey.IncomingMessage to "受信メッセージ",
    WebStringKey.CertificateIssuer to "証明書発行者が一致",
    WebStringKey.DomainAgeTrust to "ドメイン年齢 > 5年",
    WebStringKey.WhitelistedRank to "Alexaトップ1k",
    WebStringKey.GameEducationalNote to "教育ノート",
    WebStringKey.GameHintTitle to "ゲームヒント",
    WebStringKey.AddToAllowlistTitle to "許可リストに追加",
    WebStringKey.AddToBlocklistTitle to "ブロックリストに追加",
    WebStringKey.EnterDomainPrompt to "ドメインを入力",
    WebStringKey.LatencyMs to "レイテンシ",
    WebStringKey.StreakFire to "連続",
    WebStringKey.AccuracyPercent to "精度",
    WebStringKey.ConfidencePercent to "信頼度",
    WebStringKey.English to "英語",
    WebStringKey.German to "ドイツ語",
    WebStringKey.Spanish to "スペイン語",
    WebStringKey.French to "フランス語",
    WebStringKey.ChineseSimplified to "中国語(簡体)",
    WebStringKey.Japanese to "日本語",
    WebStringKey.Hindi to "ヒンディー語",
    WebStringKey.Arabic to "アラビア語",
    WebStringKey.Indonesian to "インドネシア語",
    WebStringKey.Italian to "イタリア語",
    WebStringKey.Korean to "韓国語",
    WebStringKey.Portuguese to "ポルトガル語",
    WebStringKey.Russian to "ロシア語",
    WebStringKey.Thai to "タイ語",
    WebStringKey.Turkish to "トルコ語",
    WebStringKey.Vietnamese to "ベトナム語"
,
    WebStringKey.ComponentVoting to "コンポーネント投票",
    WebStringKey.Heuristic to "ヒューリスティック",
    WebStringKey.MLModel to "MLモデル",
    WebStringKey.Brand to "ブランド",
    WebStringKey.TLD to "TLD",
    WebStringKey.VotingExplanation to "多数決で判定: 3+安全=緑、2+悪意=赤"
,
    // Results Page Placeholders,
    WebStringKey.WaitingForScan to "スキャン待機中...",
    WebStringKey.WaitingForAnalysis to "分析待機中...",
    WebStringKey.ScanURLToSeeResults to "URLをスキャンして詳細な結果を確認してください。",

    // Keyboard Shortcuts & Settings
    WebStringKey.KeyboardShortcuts to "キーボードショートカット",
    WebStringKey.StartScanner to "スキャナーを開始",
    WebStringKey.CloseMenuModal to "メニュー / モーダルを閉じる",
    WebStringKey.NavigateToDashboard to "ダッシュボードへ移動",
    WebStringKey.NavigateToHistory to "スキャン履歴",
    WebStringKey.NavigateToTrust to "トラストセンター / 許可リスト",
    WebStringKey.NavigateToGame to "ボットに勝てゲーム",
    WebStringKey.ShowHelp to "ヘルプを表示",
    WebStringKey.GotIt to "了解",
    WebStringKey.SecuritySettings to "セキュリティ設定",
    WebStringKey.SensitivityLevel to "感度レベル",
    WebStringKey.AutoBlockThreats to "脅威を自動ブロック",
    WebStringKey.RealTimeScanning to "リアルタイムスキャン",
    WebStringKey.SoundAlerts to "音声アラート",
    WebStringKey.ThreatAlerts to "脅威アラート",
    WebStringKey.ShowConfidenceScore to "信頼スコアを表示",
    WebStringKey.CompactView to "コンパクト表示",
    WebStringKey.ResetDefaults to "デフォルトにリセット",
    WebStringKey.SaveAndContinue to "保存して続行",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "Mehr Guard Securityについて",
    WebStringKey.ActualDomain to "実際のドメイン",
    WebStringKey.AnalysisComplete to "分析完了",
    WebStringKey.AutoBlockThreatsDesc to "脅威を自動的にブロック",
    WebStringKey.AwaitingScanLabel to "スキャン待機中",
    WebStringKey.BrandImpersonation to "ブランドなりすまし",
    WebStringKey.CautionAdvised to "注意が必要",
    WebStringKey.CompactViewDesc to "コンパクト表示",
    WebStringKey.DoNotVisit to "アクセスしないでください",
    WebStringKey.DoNotVisitDesc to "高信頼度のフィッシングを検出。このURLには複数の悪意のある指標があります。",
    WebStringKey.DomainUsesInternationalChars to "このドメインは正規のドメインを模倣する可能性のある国際文字を使用しています。",
    WebStringKey.GoToScanner to "スキャナーへ移動",
    WebStringKey.Hebrew to "ヘブライ語",
    WebStringKey.HelpKeyboardShortcuts to "キーボードショートカット",
    WebStringKey.HeuristicAnalysis to "ヒューリスティック分析",
    WebStringKey.HeuristicAnalysisDesc to "分析エンジンが検出した複数のリスク要因に基づいてURLにフラグが付けられました。",
    WebStringKey.HiddenDestination to "隠された宛先",
    WebStringKey.HighRisk to "高リスク",
    WebStringKey.HighRiskLabel to "高リスク",
    WebStringKey.HomographIdnAttack to "ホモグラフ / IDN攻撃",
    WebStringKey.InternationalizedDomainDetected to "国際化ドメイン名を検出しました。",
    WebStringKey.JustNow to "たった今",
    WebStringKey.KeyboardShortcutsDesc to "クイックアクセス用キーボードショートカット",
    WebStringKey.LiveFeedActive to "ライブフィードアクティブ",
    WebStringKey.LowRisk to "低リスク",
    WebStringKey.LowRiskLabel to "低リスク",
    WebStringKey.Malicious to "悪意あり",
    WebStringKey.MediumRiskLabel to "中リスク",
    WebStringKey.NoData to "データなし",
    WebStringKey.NoScanDataResults to "スキャンデータがありません。URLをスキャンして分析結果を表示してください。",
    WebStringKey.NoUrlScanned to "URLがスキャンされていません",
    WebStringKey.Persian to "ペルシャ語",
    WebStringKey.PhishingIndicators to "フィッシング指標",
    WebStringKey.ProceedWithCaution to "注意して進んでください",
    WebStringKey.ProceedWithCautionDesc to "いくつかの疑わしい指標が検出されました。機密情報を入力する前にソースを確認してください。",
    WebStringKey.RealTimeScanningDesc to "リアルタイムスキャン",
    WebStringKey.RedirectShortenerDetected to "リダイレクト/短縮URLを検出",
    WebStringKey.SafeToVisit to "アクセス安全",
    WebStringKey.SafeToVisitDesc to "ローカルヒューリスティックv2.4で検証済み。フィッシングパターン、難読化スクリプト、ブラックリスト一致は見つかりませんでした。",
    WebStringKey.SafetyScore to "安全スコア",
    WebStringKey.ScanCompleteLabel to "スキャン完了",
    WebStringKey.ScanToAnalyze to "QRコードをスキャンするかURLを入力して分析してください。",
    WebStringKey.ScannedURLLabel to "スキャンされたURL",
    WebStringKey.SecuritySignal to "セキュリティシグナル",
    WebStringKey.SensitivityLevelDesc to "感度レベル",
    WebStringKey.SensitivityPermissive to "許容的",
    WebStringKey.SensitivityStrict to "厳格",
    WebStringKey.SettingsDetection to "検出",
    WebStringKey.SettingsDisplay to "表示",
    WebStringKey.SettingsLanguage to "言語",
    WebStringKey.SettingsLanguageDesc to "UI言語を選択",
    WebStringKey.SettingsNotifications to "通知",
    WebStringKey.SettingsSavedAutomatically to "設定は自動的に保存され、セッション間で同期されます。",
    WebStringKey.ShowConfidenceScoreDesc to "信頼スコアを表示",
    WebStringKey.SoundAlertsDesc to "サウンドアラート",
    WebStringKey.SuspiciousDomain to "疑わしいドメイン",
    WebStringKey.SuspiciousEncoding to "疑わしいエンコーディング",
    WebStringKey.SuspiciousKeywords to "疑わしいキーワード",
    WebStringKey.SuspiciousTld to "疑わしいTLD",
    WebStringKey.SuspiciousTldDesc to "ドメインは悪意のあるサイトに一般的に関連付けられている{tld} TLDを使用しています。",
    WebStringKey.SuspiciousUrlParams to "疑わしいURLパラメータ",
    WebStringKey.SuspiciousUrlParamsDesc to "URLには複雑または難読化された可能性のあるパラメータが含まれています。",
    WebStringKey.ThreatAlertsDesc to "脅威アラート",
    WebStringKey.ThreatDetected to "脅威を検出",
    WebStringKey.UnableToDetermine to "判定を決定できません。もう一度お試しください。",
    WebStringKey.Unknown to "不明",
    WebStringKey.UnknownURL to "不明なURL",
    WebStringKey.UrlShortenerDesc to "URLは最終的な宛先を隠す短縮サービスを使用しています。",
    WebStringKey.UrlShortenerDetected to "URL短縮を検出",
    WebStringKey.VersionOfflineReady to "オフライン準備完了",
    WebStringKey.VisualAppearance to "視覚的外観",
    WebStringKey.WaitingForAnalysisLabel to "分析を待っています..."
)

internal val JapaneseCommonStrings = mapOf(
    "\"Always expand short links before scanning. The bot does this automatically by following redirect headers without rendering the page.\"" to "「スキャンする前に必ず短いリンクを展開してください。ボットは、ページを表示せずにリダイレクト ヘッダーに従ってこれを自動的に実行します。」",
    "\"AusPost: Your parcel failed delivery due to incorrect address details. Please update immediately via the link above to avoid return.\"" to "「AusPost: 住所の詳細が間違っているため、荷物が配達できませんでした。返品を避けるために、上記のリンクからすぐに更新してください。」",
    "\"Commonwealth Bank: Your account has been locked due to suspicious activity. Verify your identity immediately.\"" to "「コモンウェルス銀行: 不審な行為により口座がロックされています。直ちに本人確認を行ってください。」",
    "\"Let's Encrypt (R3)\"" to "「Let's Encrypt」 (R3)\"",
    "\"Phishing\"" to "「フィッシング」",
    "\"You won a \$500 gift card! Click to claim your prize.\"" to "「\$500 のギフトカードを獲得しました! クリックして賞品を受け取りましょう。」",
    "\"Your Apple ID was used to sign in on a new device. If this was not you, verify immediately.\"" to "「あなたの Apple ID が新しいデバイスでのサインインに使用されました。あなたではない場合は、すぐに確認してください。」",
    "\"Your PayPal account has been limited. Please update your information.\"" to "「あなたの PayPal アカウントは制限されています。情報を更新してください。」",
    "+10-15 points — Context-dependent signal" to "+10 ～ 15 ポイント。シグナル",
    "+10-15 points — Suggestive but not conclusive" to "+10-15 ポイント — 示唆的だが決定的ではない",
    "+10-15 points — Suspicious but not definitive" to "+10-15 ポイント — 疑わしいが決定的ではない",
    "+10-20 points — Contributes to overall risk score" to "+10-20 ポイント — 全体的なリスク スコアに寄与",
    "+15-20 points — Requires caution, not definitive" to "+15-20 ポイント — 決定的ではなく注意が必要",
    "+15-20 points — Requires destination inspection" to "+15-20 ポイント — 目的地が必要検査",
    "+15-20 points — Security baseline not met" to "+15～20 ポイント - セキュリティ ベースラインを満たしていません",
    "+20-30 points — Deliberate deception technique" to "+20～30 ポイント - 意図的な欺瞞テクニック",
    "+20-30 points — Legitimate brands rarely use these" to "+20～30 ポイント - 正規のブランドがこれらを使用することはほとんどありません",
    "+25-30 points — Strong phishing indicator" to "+25～30 ポイント - 強力なフィッシング指標",
    "+30-35 points — Requires investigation of actual characters" to "+30～35 ポイント - 実際のセキュリティの調査が必要文字",
    "+30-40 points — This is a primary phishing indicator" to "+30～40 ポイント — これは主要なフィッシング指標です",
    "+40-50 points — Advanced attack requiring intentional deception" to "+40～50 ポイント — 意図的な欺瞞を必要とする高度な攻撃",
    "+5-10 points — Minor signal" to "+5～10 ポイント — マイナーシグナル",
    "- Heuristics: {list}" to "- ヒューリスティック: {list}",
    "- Redirects: {count}" to "- リダイレクト: {count}",
    "- SSL Issuer: {issuer}" to "- SSL 発行者: {issuer}",
    "- Threat Type: {type}" to "- 脅威の種類: {type}",
    "1 hr ago • Phishing" to "1 時間前 • フィッシング",
    "100% offline" to "100% オフライン",
    "2 hours ago" to "2 時間前",
    "2 mins ago • Safe" to "2 分前 • 安全",
    "25+ AI Heuristics" to "25 以上の AI ヒューリスティック",
    "3 hops detected involving known URL shorteners." to "既知の URL 短縮機能に関連する 3 つのホップが検出されました。",
    "3 hrs ago • Safe" to "3時間前 • 安全",
    "350 pts" to "350 ポイント",
    "400 pts" to "400 ポイント",
    "5 hrs ago • Safe" to "5 時間前 • 安全",
    "< 24 hours" to "< 24 時間",
    "A phishing attempt was successfully blocked" to "フィッシングの試みは正常にブロックされました",
    "A shorter, cleaner URL would reduce this signal contribution by ~8 points." to "より短くクリーンな URL では、このシグナル寄与が最大 8 ポイント減少します。",
    "AD" to "AD",
    "AI-powered phishing detection running 100% offline in your browser." to "AI 搭載フィッシング検出はブラウザで 100% オフラインで実行されます。",
    "AI-powered phishing detection that runs" to "AI を利用したフィッシング検出が実行されます",
    "AM" to "AM",
    "About Mehr Guard" to "[[ブランド]] について",
    "Accuracy" to "精度",
    "Accuracy:" to "精度:",
    "Acknowledgements" to "確認応答",
    "Active" to "アクティブ",
    "Active Protection" to "アクティブな保護",
    "Active Scanner" to "アクティブスキャナ",
    "Actual Punycode (Where it goes)" to "実際の Punycode (どこに行くか)",
    "Add Domain" to "ドメインを追加",
    "Add manually" to "手動で追加",
    "Add to Allowlist" to "許可リストに追加",
    "Add to Blocklist" to "ブロックリストに追加",
    "Added 1 week ago" to "1 週間前に追加",
    "Added 2 days ago" to "2 日前に追加",
    "Added {domain} to {list}" to "{domain} を {list} に追加",
    "Adjust heuristic thresholds. Higher sensitivity may increase false positives." to "調整ヒューリスティックしきい値。感度を高くすると誤検知が増加する可能性があります。",
    "Alex Chen" to "Alex Chen",
    "Alex Morgan" to "Alex Morgan",
    "Alexa Top 1000 site" to "Alexa Top 1000 site",
    "All URLs will show as MALICIOUS for demo purposes" to "すべての URL はデモ目的で MALICIOUS として表示されます",
    "All code execution happens in an ephemeral container that is destroyed after each scan. This ensures malicious payloads can never escape to your system." to "すべてのコードの実行は、各スキャン後に破棄される一時的なコンテナ内で行われます。これにより、悪意のあるペイロードがシステムに逃げ出すことがなくなります。",
    "All notifications marked as read" to "既読としてマークされたすべての通知",
    "Allow List" to "許可リスト",
    "Allowlist" to "許可リスト",
    "Analysed offline." to "オフラインで分析されました。",
    "Analysis" to "分析",
    "Analysis Complete" to "分析完了",
    "Analysis Engine Loading..." to "分析エンジン読み込み中...",
    "Analysis Summary" to "分析概要",
    "Analysis Time" to "分析時間",
    "Analyze" to "分析",
    "Analyze This URL" to "この URL を分析",
    "Analyze URL" to "URL を分析",
    "Analyzed offline in <5ms" to "5 ミリ秒未満でオフラインで分析",
    "Analyzing offline..." to "オフラインで分析中...",
    "Anonymous Telemetry" to "匿名テレメトリ",
    "Anonymous Telemetry disabled" to "匿名テレメトリ無効",
    "Anonymous Telemetry enabled" to "匿名テレメトリが有効",
    "Apple Support" to "Apple サポート",
    "Apple only uses apple.com for all account-related activities. Be wary of domains containing brand names but with different extensions." to "Apple はすべてのアカウント関連のアクティビティに apple.com のみを使用します。ブランド名を含むが拡張子が異なるドメインには注意してください。",
    "Apple would never use a third-party domain for account verification. Check the actual domain name." to "Apple がアカウントの確認にサードパーティのドメインを使用することはありません。実際のドメイン名を確認してください。",
    "Are you sure you want to end this session? Progress will be lost." to "このセッションを終了してもよろしいですか?進行状況は失われます。",
    "Atlassian" to "Atlassian",
    "Atlassian is a legitimate software company. Their primary domain atlassian.com is trustworthy." to "Atlassian は正規のソフトウェア会社です。プライマリ ドメイン atlassian.com は信頼できます。",
    "Attack Breakdown" to "攻撃の内訳",
    "Attackers create domains that look like trusted brands to steal credentials" to "攻撃者は認証情報を盗むために信頼できるブランドに見えるドメインを作成",
    "Auto-Block Threats" to "自動ブロック脅威",
    "Auto-Copy Safe Links" to "自動コピーの安全なリンク",
    "Auto-Copy Safe Links disabled" to "自動コピーの安全なリンクは無効",
    "Auto-Copy Safe Links enabled" to "自動コピーの安全なリンク有効",
    "Automatically block high-risk URLs" to "高リスクの URL を自動的にブロック",
    "Back online" to "オンラインに戻る",
    "Back to Dashboard" to "ダッシュボードに戻る",
    "Balanced" to "バランス",
    "Balanced Mode (Recommended)" to "バランス モード (推奨)",
    "Beat the Bot" to "ボットを倒す",
    "Beat the Bot →" to "ボットを倒す →",
    "Best Streak" to "ベストストリーク",
    "Blacklist Match" to "ブラックリストの一致",
    "Blacklist Status" to "ブラックリストのステータス",
    "Block & Report" to "ブロックして報告",
    "Blocklist" to "ブロックリスト",
    "Bot Score" to "ボットスコア",
    "Brand Impersonation" to "ブランドのなりすまし",
    "Brand Impersonation Detected" to "ブランドのなりすましが検出されました",
    "Brands Detected" to "検出されたブランド",
    "Browser Preview" to "ブラウザプレビュー",
    "Built for" to "のために作られました",
    "CLEAN" to "クリーン",
    "CRITICAL" to "致命的",
    "Camera API (QR scanning unavailable)" to "カメラ API (QR スキャンは利用できません)",
    "Camera Access Required" to "カメラへのアクセスが必要です",
    "Camera Not Available" to "カメラが使用できません",
    "Camera activated" to "カメラが起動しました",
    "Camera error: {error}" to "カメラエラー: {error}",
    "Camera not supported in this browser" to "このブラウザではカメラがサポートされていません",
    "Camera permission denied" to "カメラの許可が拒否されました",
    "Can redirect through tracking or to malicious destinations" to "追跡を通じて、または悪意のある宛先にリダイレクトされる可能性があります",
    "Cancel" to "キャンセル",
    "Caution" to "注意",
    "Caution Advised" to "注意が必要です",
    "Certificate Issuer matches domain owner (DigiCert Inc)" to "証明書発行者がドメイン所有者と一致する (DigiCert Inc)",
    "Certificate Issuer matches domain owner (DigiCert Inc)." to "証明書発行者はドメイン所有者 (DigiCert Inc) と一致します。",
    "Certificate issued by DigiCert Inc. No anomalies in chain of trust." to "DigiCert Inc. によって発行された証明書。信頼チェーンに異常はありません。",
    "Certificate issued by trusted CA. No anomalies in chain of trust." to "信頼できる CA によって発行された証明書。信頼の連鎖に異常はない。",
    "Certificate recently issued or self-signed. Proceed with caution." to "最近発行された証明書または自己署名された証明書。慎重に作業を進めてください。",
    "Challenge our offline AI engine. Can you spot the phish faster?" to "オフライン AI エンジンに挑戦してください。フィッシングをより早く見つけることができますか?",
    "Characters like Cyrillic \"а\" look identical to Latin \"a\" but are different" to "キリル文字の「а」のような文字はラテン語の「a」と同じに見えますが、異なります。",
    "Check for Updates" to "アップデートをチェックする",
    "Check the domain carefully. This appears to be a well-known, trusted domain." to "ドメインをよく確認してください。これはよく知られた信頼できるドメインのようです。",
    "Choose Format" to "フォーマットの選択",
    "Clear All" to "すべてクリア",
    "Clear History" to "履歴をクリアする",
    "Clear scan history?" to "スキャン履歴をクリアしますか?",
    "Click a sample below or paste any URL:" to "以下のサンプルをクリックするか、任意の URL を貼り付けます。",
    "Close" to "近い",
    "Code execution happens in an ephemeral container. Malicious payloads never touch your OS kernel." to "コードの実行は一時的なコンテナーで行われます。悪意のあるペイロードが OS カーネルに影響することはありません。",
    "Combined with other signals, suggests intent to steal credentials" to "他の信号と組み合わせると、認証情報を盗む意図があることが示唆されます。",
    "Compact View" to "コンパクトビュー",
    "Compact view" to "コンパクトビュー",
    "Complete analysis is performed locally. Your camera feed and scanned data never touch an external server, ensuring absolute privacy." to "完全な分析はローカルで実行されます。カメラ フィードとスキャン データが外部サーバーに触れることはなく、絶対的なプライバシーが確保されます。",
    "Confidence Score" to "信頼スコア",
    "Confidence score" to "信頼スコア",
    "Confidence: 99.8%" to "信頼性: 99.8%",
    "Configure formats and download your threat analysis." to "形式を設定し、脅威分析をダウンロードします。",
    "Congratulations! You beat the bot!" to "おめでとう！ボットを倒しました!",
    "Continue Anyway" to "とにかく続ける",
    "Copy" to "コピー",
    "Copy Link" to "リンクをコピー",
    "Copy trusted URLs to clipboard." to "信頼できる URL をクリップボードにコピーします。",
    "Core v2.4.1 • Build 2024.12.19" to "コア v2.4.1 • ビルド 2024.12.19",
    "Correct Decision!" to "正しい決断！",
    "Correct!" to "正しい！",
    "Could not save theme preference:" to "テーマ設定を保存できませんでした:",
    "Couldn\\'t Read QR Code" to "QR コードを読み取れませんでした",
    "Credential Harvesting Path" to "資格情報収集パス",
    "Credential Harvesting Path (/login)" to "資格情報収集パス (/login)",
    "Current" to "現在",
    "Cyrillic characters mimicking Latin alphabet detected." to "ラテン文字を模倣したキリル文字が検出されました。",
    "DB CHECK" to "DBチェック",
    "DISCONNECTED" to "切断されました",
    "DO NOT VISIT" to "訪問しないでください",
    "DOMAIN" to "ドメイン",
    "Dangerous" to "危険な",
    "Dark" to "暗い",
    "Dashboard" to "ダッシュボード",
    "Data Lifecycle Verification" to "データのライフサイクル検証",
    "Data Point" to "データポイント",
    "Data exported successfully!" to "データは正常にエクスポートされました。",
    "Data sent without encryption can be intercepted" to "暗号化せずに送信されたデータは傍受される可能性がある",
    "Database Updated" to "データベースが更新されました",
    "Decoded URL/Payload" to "デコードされた URL/ペイロード",
    "Deep subdomains can hide the actual domain at the end" to "深いサブドメインは最後に実際のドメインを隠すことができます",
    "Destination URL obfuscated. Unable to verify final target." to "宛先 URL は難読化されています。最終目標を確認できません。",
    "Details" to "詳細",
    "Detection" to "検出",
    "Deutsch" to "ドイツ語",
    "Disable all external link previews." to "すべての外部リンクのプレビューを無効にします。",
    "Display" to "画面",
    "Display threat probability percentage" to "脅威の確率をパーセンテージで表示",
    "Do Not Visit This URL" to "この URL にはアクセスしないでください",
    "Domain \"apple-id-verify.com\" is not owned by Apple" to "ドメイン「apple-id-verify.com」は Apple が所有するものではありません",
    "Domain age > 5 years (High trust)." to "ドメインの年齢 > 5 年 (高信頼)。",
    "Domain age is less than 24 hours." to "ドメインの有効期限が 24 時間未満です。",
    "Domain already in list" to "ドメインはすでにリストにあります",
    "Domain contains \"xn--\" IDN encoding" to "ドメインに「xn--」IDN エンコーディングが含まれている",
    "Domain contains or mimics a known brand name (PayPal, Amazon, etc.)" to "ドメインに既知のブランド名 (PayPal、Amazon など) が含まれている、またはそれを模倣している",
    "Domain mimics known brand (PayPal → Paypa1). High-confidence phishing." to "ドメインは既知のブランドを模倣しています (PayPal → Paypa1)。信頼性の高いフィッシング。",
    "Domain mimics legitimate bank (commbank.com.au)" to "ドメインは正規の銀行 (commbank.com.au) を模倣しています",
    "Domain or path contains random-looking character sequences" to "ドメインまたはパスにランダムに見える文字シーケンスが含まれています",
    "Domain registered > 5 years ago. Low probability of churn-and-burn." to "ドメインは 5 年以上前に登録されています。チャーンアンドバーンの可能性が低い。",
    "Domain registered in the last 24 hours" to "過去 24 時間以内に登録されたドメイン",
    "Domain uses common misspellings or character substitutions (paypa1, amaz0n)" to "ドメインで一般的なスペルミスまたは文字置換が使用されている (paypa1、amaz0n)",
    "Domain uses suspicious hyphenated structure (verify-deliveries.net)" to "ドメインで不審なハイフン構造が使用されている (verify-deliveries.net)",
    "Don't just get a \"Block\". We provide detailed heuristic breakdowns of URL parameters, redirects, and javascript payloads." to "単に「ブロック」されるだけではありません。 URL パラメータ、リダイレクト、JavaScript ペイロードの詳細なヒューリスティックな内訳を提供します。",
    "Download Apps" to "アプリをダウンロードする",
    "Drag & Drop QR code image here" to "QRコード画像をここにドラッグ＆ドロップ",
    "Drag & drop a QR code image here or enable camera access to start scanning." to "ここに QR コード画像をドラッグ アンド ドロップするか、カメラ アクセスを有効にしてスキャンを開始します。",
    "Educational Note" to "教育ノート",
    "Embedded Redirect" to "埋め込みリダイレクト",
    "Enable Camera" to "カメラを有効にする",
    "Enable camera first" to "最初にカメラを有効にする",
    "End Session" to "セッションを終了",
    "Engine" to "エンジン",
    "Engine Active" to "エンジンがアクティブ",
    "Engine Active (Offline)" to "エンジンがアクティブ (オフライン)",
    "Engine initializing, please wait..." to "エンジンを初期化中です。お待ちください...",
    "Engine initializing..." to "エンジンを初期化中...",
    "Engine not ready, using demo mode" to "エンジンの準備ができていません。デモを使用していますモード",
    "English" to "英語",
    "Enter" to "Enter",
    "Enter URL" to "URLを入力",
    "Enter URL Manually" to "URLを手動で入力",
    "Enterprise Plan" to "エンタープライズ プラン",
    "Enterprise Protection Active" to "エンタープライズ保護がアクティブ",
    "Esc" to "Esc",
    "Escape" to "エスケープ",
    "Español" to "スペイン語",
    "Established Domain" to "確立されたドメイン",
    "Excessive Subdomains" to "超過サブドメイン",
    "Excessively Long URL" to "長すぎる URL",
    "Exit" to "終了",
    "Explainable Defence." to "説明可能な防御。",
    "Explainable Security" to "説明可能なセキュリティ",
    "Export" to "エクスポート",
    "Export Report" to "エクスポート レポート",
    "Export Reports" to "エクスポート レポート",
    "Exports include all identified threat vectors, headers, and the raw payload analysis." to "エクスポートには、特定されたすべての脅威ベクトル、ヘッダー、生のペイロード分析が含まれます。",
    "External Transmission" to "外部送信",
    "FAIL" to "FAIL",
    "Failed to copy link" to "リンクのコピーに失敗しました",
    "Failed to copy report" to "レポートのコピーに失敗しました",
    "Failed to get scan statistics:" to "スキャン統計の取得に失敗しました:",
    "Failed to load image" to "画像のロードに失敗しました",
    "Failed to read file" to "ファイルの読み取りに失敗しました",
    "Failed to share" to "共有に失敗しました",
    "Failed to share report" to "レポートの共有に失敗しました",
    "File upload (image scanning unavailable)" to "ファイルのアップロード (画像スキャン)利用不可)",
    "Final Destination" to "最終宛先",
    "Final Results" to "最終結果",
    "Fix it" to "修正します",
    "For the best experience, use Chrome, Firefox, Safari, or Edge." to "最高のエクスペリエンスを得るには、Chrome、Firefox、Safari、または Edge を使用してください。",
    "Found in 3 local offline threat databases." to "3 つのローカル オフライン脅威データベースで見つかりました。",
    "Français" to "Français",
    "Free/cheap TLDs are heavily abused for throwaway phishing domains" to "無料/安価な TLD は使い捨てフィッシングに頻繁に悪用されていますドメイン",
    "Gallery" to "ギャラリー",
    "Game Over!" to "ゲーム オーバー!",
    "Generate Test QR" to "テスト QR を生成",
    "Generate a test malicious QR code" to "テスト用の悪意のある QR コードを生成",
    "Generated on Dec 29, 2025 • 14:32:01 UTC" to "2025 年 12 月 29 日 • 14:32:01 UTC に生成",
    "Generated on {date} • {time} UTC" to "{date} • {time} UTC に生成",
    "Generating {format} report..." to "生成中{format} レポート...",
    "Get Started! 🚀" to "始めましょう! 🚀",
    "GitHub" to "GitHub",
    "GitHub.com is a legitimate developer platform owned by Microsoft. Always verify the exact domain spelling." to "GitHub.com は、Microsoft が所有する正規の開発者プラットフォームです。常に正確なドメインのスペルを確認してください。",
    "Gmail" to "Gmail",
    "Google Docs" to "Google ドキュメント",
    "Google Docs uses docs.google.com. Always verify the sender knows you before opening shared documents." to "Google ドキュメントでは docs.google.com を使用します。共有ドキュメントを開く前に、送信者があなたを知っていることを必ず確認してください。",
    "Google services use subdomains of google.com. mail.google.com is the legitimate Gmail address." to "Google サービスは google.com のサブドメインを使用します。 mail.google.com は正規の Gmail アドレスです。",
    "Got it" to "わかりました",
    "HIGH" to "高",
    "HIGH RISK" to "高リスク",
    "HIGH RISK DETECTED" to "高リスクが検出されました",
    "HTTP instead of HTTPS (no encryption)" to "HTTPS ではなく HTTP (暗号化なし)",
    "HTTPS" to "HTTPS",
    "Help" to "ヘルプ",
    "Heuristic Engine" to "ヒューリスティックエンジン",
    "Heuristics" to "ヒューリスティック",
    "Hides the true destination URL from the user" to "本当の宛先 URL をユーザーから隠します",
    "High" to "高",
    "High Entropy" to "高エントロピー",
    "High Risk" to "高リスク",
    "High entropy string detected in URL parameters." to "URL パラメーターで高エントロピー文字列が検出されました。",
    "High-Performance Engine" to "高パフォーマンス エンジン",
    "High-Risk TLD" to "高リスク TLD",
    "High-Risk URL Blocked" to "高リスク URLブロックされました",
    "High-confidence phishing detected. This URL exhibits multiple malicious indicators." to "信頼性の高いフィッシングが検出されました。この URL には複数の悪意のある兆候が表示されます。",
    "Hold steady. Analysed offline in <5ms." to "そのままお待ちください。オフラインで 5 ミリ秒未満で分析されました。",
    "Home" to "ホーム",
    "Homograph / IDN Attack" to "同型異型文字攻撃 / IDN 攻撃",
    "Homograph Attack" to "同型文字攻撃",
    "Homograph attack: \"c0mmonwealth\" uses zero instead of letter O" to "同型文字攻撃: \"c0mmonwealth\" は文字 O の代わりにゼロを使用します",
    "Homograph attack: \"paypa1\" uses number 1 instead of letter L" to "同型文字攻撃: \"paypa1\" は文字 L の代わりに数字 1 を使用します",
    "Homograph attacks use similar-looking characters. Always check URLs character by character for suspicious substitutions." to "同型文字攻撃では、似たような文字が使用されます。 URL に疑わしい置換が含まれていないか常に 1 文字ずつ確認してください。",
    "How aggressive should threat detection be?" to "脅威検出はどの程度積極的に行う必要がありますか?",
    "Human-Readable Report" to "人間が判読できるレポート",
    "I am reporting a suspected phishing URL detected by Mehr Guard:" to "Mehr Guard:",
    "ID: scan_2023_10_24_af92" to "ID: scan_2023_10_24_af92",
    "ID: {id}" to "ID: によって検出されたフィッシングの疑いのある URL を報告します。 {id}",
    "INFO" to "情報",
    "IP Address Host" to "IP アドレス ホスト",
    "If HTTPS was used, this signal would not trigger and score would drop by ~18 points." to "HTTPS が使用されている場合、このシグナルはトリガーされず、スコアは約 18 ポイント低下します。",
    "If a registered domain name was used instead of IP address, score would drop by ~28 points." to "IP アドレスの代わりに登録されたドメイン名が使用された場合、スコアは約 28 ポイント低下します。",
    "If all characters were ASCII Latin letters, this signal would not trigger and score would drop by ~45 points." to "すべての文字が ASCII ラテン文字の場合、このシグナルはトリガーされず、スコアは約 45 ポイント低下します。ポイント。",
    "If no embedded URLs were present in query parameters, score would drop by ~18 points." to "クエリ パラメーターに埋め込み URL が存在しない場合、スコアは最大 18 ポイント低下します。",
    "If only 1-2 subdomains were used, this signal would not trigger. Score would drop by ~12 points." to "1 ～ 2 つのサブドメインのみが使用されている場合、このシグナルはトリガーされません。スコアは最大 12 ポイント低下します。",
    "If the domain spelled the brand correctly without substitutions, score would drop by ~25 points." to "ドメインが置換なしでブランドのスペルを正しく表記した場合、スコアは最大 25 ポイント低下します。",
    "If the domain used only ASCII characters (no IDN), score would drop by ~32 points." to "ドメインで ASCII 文字のみ (IDN なし) が使用されている場合、スコアは最大 32 ポイント低下します。",
    "If the domain used readable words instead of random characters, score would drop by ~12 points." to "ドメインがランダムな文字の代わりに読みやすい単語を使用している場合、スコアは最大 12 ポイント低下します。",
    "If the full destination URL was visible, score would drop by ~18 points (assuming destination is safe)." to "完全なリンク先 URL が表示されている場合、スコアは最大 12 ポイント低下します。最大 18 ポイント低下します (宛先が安全であると仮定)。",
    "If this URL used .com, .org, or country TLDs, score would drop by ~25 points." to "この URL が .com、.org、または国の TLD を使用した場合、スコアは最大 25 ポイント低下します。",
    "If this were the official brand domain (paypal.com), this signal would not trigger and score would drop by ~35 points." to "これが公式ブランド ドメイン (paypal.com) である場合、このシグナルはトリガーされず、スコアは最大 35 ポイント低下します。",
    "Import Image" to "画像のインポート",
    "Imported: {name}" to "インポート済み: {name}",
    "Incoming Message (+61 491 570 010):" to "受信メッセージ (+61 491 570 010):",
    "Incorrect Decision" to "間違った決定",
    "Intermediate Hop" to "中間ホップ",
    "International domains can hide malicious lookalike characters" to "国際ドメインは悪意のある類似文字を隠す可能性があります",
    "Invalid URL Format" to "無効な URL 形式",
    "Invalid URL format" to "無効な URL 形式",
    "Invalid theme:" to "無効なテーマ:",
    "Isolated Sandbox" to "分離サンドボックス",
    "It's a Tie!" to "これは引き分けです!",
    "JS" to "JS",
    "JSON format. Best for SIEM integration." to "JSON 形式。 SIEM 統合に最適。",
    "JSON report downloaded" to "ダウンロードされた JSON レポート",
    "John Smith" to "John Smith",
    "Judge Mode" to "ジャッジ モード",
    "Judge Mode Active" to "ジャッジ モード アクティブ",
    "Judge Mode OFF - Normal detection active" to "ジャッジ モード オフ - 通常の検出がアクティブ",
    "Judge Mode: Force MALICIOUS results for demo" to "ジャッジ モード: デモに悪意のある結果を強制する",
    "Judge Mode: ON" to "ジャッジ モード: オン",
    "Just now" to "今だけ",
    "Kotlin Multiplatform" to "Kotlinマルチプラットフォーム",
    "Kotlin engine not ready yet" to "Kotlin エンジンはまだ準備ができていません",
    "Kotlin/Wasm" to "Kotlin/Wasm",
    "KotlinConf Student Competition 2025-2026" to "KotlinConf Student Competition 2025-2026",
    "LIVE" to "ライブ",
    "LIVE FEED ACTIVE" to "ライブ フィードはアクティブです",
    "LIVE FEED DISCONNECTED" to "ライブ フィードは切断されました",
    "LOW" to "低",
    "LOW RISK" to "低リスク",
    "Language: {language} {flag}" to "言語: {language} {flag}",
    "Last Update" to "最終更新",
    "Latency" to "レイテンシ",
    "Latency: 2ms" to "レイテンシ: 2ms",
    "Learn about our local architecture" to "ローカル アーキテクチャについて学ぶ",
    "Learn how to identify advanced QR homograph attacks." to "高度な QR ホモグラフ攻撃を識別する方法を学びます。",
    "Legitimate" to "正規",
    "Legitimate services use domains; IPs hide identity and bypass filters" to "正規のサービスはドメインを使用します。 IP は ID を隠し、フィルターをバイパスします",
    "Let's Encrypt (R3)" to "Let's Encrypt (R3)",
    "Light" to "Light",
    "Limited Browser Support" to "制限付きブラウザ サポート",
    "Link copied to clipboard!" to "リンクをクリップボードにコピーしました!",
    "LinkedIn" to "LinkedIn",
    "LinkedIn uses linkedin.com as their primary domain. Profile URLs follow the /in/username format." to "LinkedIn は、linkedin.com をプライマリ ドメインとして使用します。プロファイル URL は /in/username の形式に従います。",
    "Live Hint" to "ライブ ヒント",
    "Live Preview" to "ライブ プレビュー",
    "Live Scanner" to "ライブ スキャナ",
    "Live Scoreboard" to "ライブ スコアボード",
    "Local DB" to "ローカル DB",
    "Local Database" to "ローカル データベース",
    "Local Memory (RAM)" to "ローカル メモリ (RAM)",
    "Local Privacy" to "ローカル プライバシー",
    "Local Sandbox" to "ローカル サンドボックス",
    "Local database v2.4.1 active. No data leaves this device." to "ローカルデータベース v2.4.1 がアクティブです。このデバイスからデータは送信されません。",
    "Local storage (history won\\'t persist)" to "ローカル ストレージ (履歴は保持されません)",
    "Long URLs can hide malicious parameters or overwhelm users" to "長い URL は悪意のあるパラメータを隠したり、ユーザーに負担をかける可能性があります",
    "Look at the domain carefully. Is \"c0mmonwealth\" spelled correctly? The number 0 is often used to replace the letter O." to "ドメインを注意深く確認してください。 「c0mmonwealth」のスペルは正しいですか?数字の 0 は、文字 O の代わりによく使用されます。",
    "Look at the domain name carefully. Is \"paypa1\" spelled correctly?" to "ドメイン名を注意深く見てください。 「paypa1」のスペルは正しいですか?",
    "Look closely at the domain structure. Legitimate organisations rarely use hyphens in the main domain name or generic TLDs like" to "ドメイン構造をよく見てください。正当な組織では、",
    "Low" to "低",
    "Low Risk" to "低リスク",
    "Low Sensitivity Mode" to "低機密モード",
    "MALICIOUS" to "MALICIOUS",
    "MEDIUM" to "MEDIUM",
    "MEDIUM RISK" to "MEDIUM RISK",
    "MINOR CONCERNS" to "MINOR のようなメイン ドメイン名や一般的な TLD にハイフンを使用することはほとんどありません。懸念事項",
    "Machine-Readable" to "機械可読",
    "Make your decision" to "決断してください",
    "Malicious" to "悪意",
    "Manage privacy controls, sensitivity, and security lists." to "プライバシー制御、機密性、およびセキュリティリストを管理します。",
    "Matched 3 signatures in local phishing DB." to "ローカルフィッシング DB で 3 つの署名が一致しました。",
    "Maximum protection. Blocks any suspicious patterns including newly registered domains, uncommon TLDs, and any URL with potential encoding tricks." to "最大限の保護。新しく登録されたドメイン、一般的ではない TLD、エンコード トリックの可能性のある URL など、疑わしいパターンをブロックします。",
    "Medium" to "中",
    "Microsoft-owned platform" to "Microsoft 所有のプラットフォーム",
    "Missing features:" to "欠落している機能:",
    "More than 3 subdomain levels (secure.login.paypal.fake.com)" to "3 つ以上のサブドメイン レベル (secure.login.paypal.fake.com)",
    "Need help? Visit our GitHub for documentation" to "サポートが必要ですか?ドキュメントについては GitHub にアクセスしてください",
    "Never trust shortened URLs from unknown sources. Use URL expander tools to see the real destination before clicking." to "未知のソースからの短縮 URL を決して信頼しないでください。クリックする前に、URL 展開ツールを使用して実際のリンク先を確認してください。",
    "Newly Registered Domain" to "新規登録ドメイン",
    "Next Round" to "次ラウンド",
    "Next →" to "次→",
    "No Cloud Logs" to "クラウド ログなし",
    "No HTTPS Encryption" to "HTTPS 暗号化なし",
    "No HTTPS encryption" to "HTTPS 暗号化なし",
    "No QR code found in image" to "画像内に QR コードが見つかりません",
    "No URL to copy" to "コピーする URL がありません",
    "No URL to open" to "コピー先の URL がありませんopen",
    "No URL to report - analyze one first" to "レポートする URL がありません - まず分析してください",
    "No camera found" to "カメラが見つかりません",
    "No custom domains blocked." to "ブロックされたカスタム ドメインはありません。",
    "No data leaves device" to "デバイスからデータが送信されることはありません",
    "No new notifications" to "新しい通知はありません",
    "No recent analysis to view" to "表示する最近の分析はありません",
    "No recent scans" to "最近のスキャンはありません",
    "No security threats were detected. The QR code leads to a verified safe destination." to "セキュリティ上の脅威は検出されませんでした。 QR コードは検証済みの安全な宛先につながります。",
    "No threats detected" to "脅威は検出されません",
    "None" to "なし",
    "Not a valid URL" to "有効な URL ではありません",
    "Not found in 52 local offline threat databases." to "52 のローカル オフライン脅威データベースには見つかりません。",
    "Not the official PayPal domain (paypal.com)" to "公式の PayPal ドメイン (paypal.com) ではありません",
    "Notifications" to "通知",
    "Obfuscated JavaScript" to "難読化されていますJavaScript",
    "Obfuscated Script" to "難読化されたスクリプト",
    "Official LinkedIn domain" to "公式 LinkedIn ドメイン",
    "Official postal services use their primary domain (auspost.com.au) for all tracking. Verify by visiting the official website directly." to "公式の郵便サービスは、すべての追跡にプライマリ ドメイン (auspost.com.au) を使用します。公式 Web サイトに直接アクセスして確認してください。",
    "Offline" to "オフライン",
    "Offline Core v2.4" to "オフライン コア v2.4",
    "Offline Engine V.2.4" to "オフライン エンジン V.2.4",
    "Offline Guarantee:" to "オフライン保証:",
    "Offline Mode" to "オフライン モード",
    "Offline Mode Active" to "オフライン モード アクティブ",
    "Offline Privacy" to "オフライン プライバシー",
    "Offline Protection" to "オフライン保護",
    "Offline Ready" to "オフライン対応",
    "Offline Security" to "オフラインセキュリティ",
    "Offline-First Architecture" to "オフラインファーストのアーキテクチャ",
    "On-Device DB" to "オンデバイスDB",
    "On-Device Database" to "オンデバイスデータベース",
    "Onboarding" to "オンボーディング",
    "Only blocks known malicious URLs from the threat database. Minimal false positives, but may miss novel attacks." to "既知の悪意のある URL のみを脅威データベースからブロックします。誤検知は最小限ですが、新たな攻撃を見逃す可能性があります。",
    "Open Safely (Sandbox)" to "安全に開く (サンドボックス)",
    "Open Source Licenses" to "オープンソースライセンス",
    "Opening PhishTank..." to "PhishTank を開いています...",
    "Opening URL in new tab" to "URLを新しいタブで開く",
    "Opening email client..." to "電子メール クライアントを開いています...",
    "Optimised for desktop environments. Scans are processed in under 5ms using native Kotlin Multiplatform binaries." to "デスクトップ環境向けに最適化されています。スキャンは、ネイティブ Kotlin マルチプラットフォーム バイナリを使用して 5 ミリ秒未満で処理されます。",
    "Overview" to "概要",
    "PASS" to "合格",
    "PDF format. Best for sharing with stakeholders." to "PDF形式。関係者との共有に最適です。",
    "PDF report ready for download" to "PDF レポートをダウンロードできるようになりました",
    "PHISH" to "フィッシング",
    "PHISHING" to "フィッシング",
    "PROCEED WITH CAUTION" to "慎重に進めてください",
    "Paranoia" to "パラノイア",
    "Paranoia Mode" to "パラノイアモード",
    "Paste URL" to "URLを貼り付け",
    "Paste URL to Analyze" to "URLを貼り付けて分析",
    "PayPal Security" to "PayPalのセキュリティ",
    "Permissive" to "寛容",
    "Phishing" to "フィッシング",
    "Phishing Attempt" to "フィッシングの試み",
    "Phishing Detection Sensitivity" to "フィッシング検出感度",
    "Phishing Engine" to "フィッシングエンジン",
    "Phishing Report: {url}" to "フィッシングレポート: {url}",
    "Phishing detection is running normally" to "フィッシング検出は正常に実行されています",
    "Play Again" to "もう一度プレイする",
    "Play Now" to "今すぐプレイ",
    "Play sound when threat detected" to "脅威が検出されたときに音を鳴らす",
    "Please drop an image file" to "画像ファイルをドロップしてください",
    "Please enter a URL" to "URLを入力してください",
    "Please enter a domain" to "ドメインを入力してください",
    "Please enter a valid domain" to "有効なドメインを入力してください",
    "Please select an image" to "画像を選択してください",
    "Point your camera at a QR code to detect" to "カメラを QR コードに向けて検出します",
    "Points" to "ポイント",
    "Press Cmd/Ctrl+V again to paste" to "Cmd/Ctrl+V をもう一度押して貼り付けます",
    "Privacy Controls" to "プライバシー管理",
    "Privacy Policy" to "プライバシーポリシー",
    "Privacy Settings" to "プライバシー設定",
    "Privacy policy: 100% offline, zero data collection" to "プライバシー ポリシー: 100% オフライン、データ収集なし",
    "Proceed with Caution" to "慎重に進めてください",
    "Processing Env" to "処理環境",
    "Processing image..." to "画像を処理中...",
    "Profile" to "プロフィール",
    "Profile updated successfully!" to "プロフィールが正常に更新されました。",
    "Punycode Domain" to "Punycode ドメイン",
    "QR Code Detected!" to "QRコードが検出されました！",
    "QR Code Scan" to "QRコードスキャン",
    "QR Code detected!" to "QRコードを検出しました！",
    "Mehr Guard" to "[[ブランド]]",
    "Mehr Guard - Beat the Bot" to "Mehr Guard - ボットを倒す",
    "Mehr Guard - Dashboard" to "[[ブランド]] - ダッシュボード",
    "Mehr Guard - Offline Privacy Onboarding" to "Mehr Guard - オフライン プライバシー オンボーディング",
    "Mehr Guard - Scan Dashboard" to "Mehr Guard - スキャン ダッシュボード",
    "Mehr Guard - Scan Result" to "Mehr Guard - スキャン結果",
    "Mehr Guard - Trust Centre" to "[[ブランド]] - トラスト センター",
    "Mehr Guard Logo" to "[[ブランド]] ロゴ",
    "Mehr Guard Results" to "[[ブランド]] 結果",
    "Mehr Guard Scan Result" to "Mehr Guard スキャン結果",
    "Mehr Guard Security Audit" to "Mehr Guard セキュリティ監査",
    "Mehr Guard Threat Analysis Report" to "Mehr Guard 脅威分析レポート",
    "Mehr Guard Threat Report" to "Mehr Guard 脅威レポート",
    "Mehr Guard Verdict: {verdict}" to "[[ブランド]] 評決: {verdict}",
    "Mehr Guard analyses potential threats directly on your hardware. Experience" to "Mehr Guard は、ハードウェア上の潜在的な脅威を直接分析します。経験",
    "Mehr Guard explains" to "[[ブランド]] の説明",
    "Mehr Guard needs camera access to scan QR codes in real-time." to "Mehr Guard は QR コードをリアルタイムでスキャンするためにカメラにアクセスする必要があります。",
    "Mehr Guard processes every scan within a secure, isolated local sandbox. We prioritize explainable security with zero cloud telemetry for image analysis." to "Mehr Guard は、安全で隔離されたローカル サンドボックス内ですべてのスキャンを処理します。画像分析用のゼロクラウドテレメトリーによる説明可能なセキュリティを優先します。",
    "Mehr Guard strictly disables all outgoing telemetry. Your scan results, URL history, and image hashes never leave your device." to "Mehr Guard は、すべての発信テレメトリを厳密に無効にします。スキャン結果、URL 履歴、画像ハッシュがデバイスから流出することはありません。",
    "Mehr Guard uses local heuristic analysis engines. No image data, URL strings, or metadata leaves this device during scanning. Your privacy is mathematically guaranteed." to "Mehr Guard はローカルのヒューリスティック分析エンジンを使用しています。スキャン中に画像データ、URL 文字列、またはメタデータがこのデバイスから流出することはありません。あなたのプライバシーは数学的に保証されています。",
    "Mehr Guard works 100% offline! All analysis is done locally on your device. No internet connection required." to "Mehr Guard は 100% オフラインで動作します!すべての分析はデバイス上でローカルに行われます。インターネット接続は必要ありません。",
    "Mehr Guard | Premium Web Scanner" to "[[ブランド]] |プレミアム Web スキャナー",
    "Mehr Guard Bot" to "QRシールドボット",
    "Quarantine in Sandbox" to "サンドボックスでの隔離",
    "Quarantined in secure sandbox for analysis" to "分析のために安全なサンドボックスに隔離",
    "READY" to "準備ができて",
    "Randomly generated domains are often temporary phishing sites" to "ランダムに生成されたドメインは一時的なフィッシング サイトであることがよくあります",
    "Raw Image Buffer" to "RAW画像バッファ",
    "Read Only" to "読み取り専用",
    "Real-Time Scanning" to "リアルタイムスキャン",
    "Real-time scanning" to "リアルタイムスキャン",
    "Recent Scans" to "最近のスキャン",
    "Recommended Actions" to "推奨されるアクション",
    "Refresh Page" to "ページを更新",
    "Removed {domain} from {list}" to "{list} から {domain} を削除しました",
    "Removing or changing the suspicious pattern would reduce the overall risk score." to "疑わしいパターンを削除または変更すると、全体的なリスク スコアが低下します。",
    "Report Export - Mehr Guard" to "レポートのエクスポート - [[ブランド]]",
    "Report Generation" to "レポートの生成",
    "Report Incorrect Verdict" to "不正確な評決を報告する",
    "Report Phishing" to "フィッシングを報告する",
    "Report URL copied to clipboard" to "レポート URL がクリップボードにコピーされました",
    "Report copied to clipboard" to "レポートをクリップボードにコピーしました",
    "Report if this verdict is wrong" to "この判決が間違っていたら報告してください",
    "Report shared" to "レポートの共有",
    "Report shared successfully!" to "レポートは正常に共有されました。",
    "Reported: {timestamp}" to "報告済み: {timestamp}",
    "Reports" to "レポート",
    "Reset Defaults" to "デフォルトにリセット",
    "Reset all Trust Centre settings to default?" to "すべてのセキュリティ センターの設定をデフォルトにリセットしますか?",
    "Reset all settings to default" to "すべての設定をデフォルトにリセットする",
    "Response" to "応答",
    "Result" to "結果",
    "Result # {id}" to "結果番号 {id}",
    "Result #8291-A" to "結果 #8291-A",
    "Result copied to clipboard!" to "結果がクリップボードにコピーされました!",
    "Results Dashboard" to "結果ダッシュボード",
    "Return to Dashboard" to "ダッシュボードに戻る",
    "Risk Assessment" to "リスクアセスメント",
    "Risk Score" to "リスクスコア",
    "Risk Score: {score}/100" to "リスクスコア: {score}/100",
    "Risk impact:" to "リスクへの影響:",
    "Round" to "ラウンド",
    "SAFE" to "安全",
    "SAFE TO VISIT" to "訪問しても安全",
    "SMS from unknown number impersonating AusPost" to "AusPostになりすました未知の番号からのSMS",
    "SSL Certificate Issues" to "SSL証明書の問題",
    "SUSPICIOUS" to "不審",
    "SUSPICIOUS ACTIVITY" to "不審なアクティビティ",
    "Safe" to "安全",
    "Safe Scans" to "安全なスキャン",
    "Safe to Visit" to "安全に訪問",
    "Safe vs Risky QR Codes" to "安全 vs 危険なQRコード",
    "Safety Score" to "安全性スコア",
    "Save & Continue" to "保存して続行",
    "Scan" to "スキャン",
    "Scan # {id}" to "スキャン番号 {id}",
    "Scan #8021-AF" to "スキャン #8021-AF",
    "Scan Another" to "別のスキャン",
    "Scan Complete" to "スキャン完了",
    "Scan History" to "スキャン履歴",
    "Scan Meta" to "スキャンメタ",
    "Scan Monitor" to "スキャン監視",
    "Scan New QR" to "新しい QR をスキャン",
    "Scan QR" to "QR をスキャン",
    "Scan QR Code" to "QR コードをスキャン",
    "Scan QR codes as they're detected" to "検出されたときに QR コードをスキャン",
    "Scan Time" to "スキャン時間",
    "Scan URLs Safely" to "URL を安全にスキャン",
    "Scan history cleared" to "スキャン履歴をクリア",
    "Scan this QR code with Mehr Guard to see malicious URL detection:" to "Mehr Guard でこの QR コードをスキャンして、悪意のある URL を確認します検出:",
    "Scanned with Mehr Guard - {url}" to "Mehr Guard - {url} でスキャン",
    "Scanner Dashboard" to "スキャナ ダッシュボード",
    "Scanning..." to "スキャン中...",
    "Scans" to "スキャン",
    "Scans for known malicious patterns and heuristic mismatches. Blocks homoglyph attacks and redirect chains. Low false positive rate expected." to "既知の悪意のあるパターンとヒューリスティックな不一致をスキャンします。同形文字攻撃とリダイレクト チェーンをブロックします。誤検知率が低いと予想されます。",
    "Secure Environment" to "安全な環境",
    "Secure. Offline." to "安全。オフライン。",
    "Security" to "セキュリティ",
    "Security Analyst" to "セキュリティ アナリスト",
    "Security Audit: PASS" to "セキュリティ監査: PASS",
    "Security Engine Active" to "セキュリティ エンジンがアクティブ",
    "Security Heuristics" to "セキュリティ ヒューリスティック",
    "Security Settings" to "セキュリティ設定",
    "Security audit report downloaded" to "ダウンロードされたセキュリティ監査レポート",
    "See Results" to "結果を見る",
    "See the difference instantly:" to "違いを見る瞬時:",
    "Sensitivity Level" to "感度レベル",
    "Sensitivity set to {level}" to "感度を {level} に設定",
    "Session ID: #GAME-" to "セッション ID: #GAME-",
    "Settings" to "設定",
    "Settings are saved automatically and sync across sessions." to "設定は自動的に保存され、セッション間で同期されます。",
    "Settings reset to default" to "設定はデフォルトにリセット",
    "Settings reset to defaults" to "設定はデフォルトにリセット",
    "Settings saved! Your data stays on-device." to "設定は保存されました!データはデバイス上に残ります。",
    "Share" to "共有",
    "Share Report" to "レポートを共有",
    "Share detection stats to improve ML." to "検出統計を共有して ML を改善します。",
    "Shared successfully!" to "正常に共有されました!",
    "Sharing not supported" to "共有はサポートされていません",
    "Short URLs hide the actual destination. Prize claims from unknown numbers are almost always scams." to "短い URL は実際の宛先を隠します。不明な番号からの賞品請求は、ほとんどの場合詐欺です。",
    "Shortened URL hides true destination" to "短縮 URL は本当の宛先を隠します",
    "Show Confidence Score" to "信頼スコアを表示",
    "Show visual alerts for threats" to "脅威に対する視覚的なアラートを表示",
    "Sign in to your GitHub account to access your repositories." to "GitHub アカウントにサインインしてリポジトリにアクセスします。",
    "Signatures" to "署名",
    "Skip" to "スキップ",
    "Some features may not work in your browser." to "一部の機能は、あなたの環境では動作しない可能性があります。ブラウザ。",
    "Some minor security concerns were identified. The link appears mostly safe but review recommended." to "いくつかの軽微なセキュリティ上の懸念が確認されました。リンクはほとんど安全であるように見えますが、確認することをお勧めします。",
    "Some suspicious indicators detected. Verify the source before entering sensitive information." to "いくつかの不審なインジケータが検出されました。機密情報を入力する前にソースを確認してください。",
    "Sound Alerts" to "サウンド アラート",
    "Sound alerts" to "サウンド アラート",
    "Source" to "ソース",
    "Standard Gmail URL structure" to "標準 Gmail URL 構造",
    "Standard Google Docs URL format" to "標準 Google ドキュメント URL 形式",
    "Standard profile URL structure" to "標準プロファイル URL 構造",
    "Status" to "ステータス",
    "Streak:" to "ストリーク:",
    "Strict" to "厳密",
    "Strict Offline Guarantee" to "厳密なオフライン保証",
    "Strict Offline Mode" to "厳密なオフライン モード",
    "Strict Offline Mode disabled" to "厳密なオフライン モードは無効です",
    "Strict Offline Mode enabled" to "厳密なオフライン モードは有効です",
    "Subdomain \"signin\" used for deception" to "欺瞞に使用されるサブドメイン「signin」",
    "Subdomain of google.com" to "google.com のサブドメイン",
    "Subdomain of google.com (trusted)" to "google.com のサブドメイン (信頼できる)",
    "Submitted via Mehr Guard" to "送信方法[[ブランド]]",
    "Success!" to "成功!",
    "Support" to "サポート",
    "Suspicious" to "不審",
    "Suspicious Redirect Chain" to "不審なリダイレクト チェーン",
    "Suspicious TLD" to "不審な TLD",
    "Suspicious TLD (.tk)" to "不審な TLD (.tk)",
    "Switch Language: English/Deutsch" to "言語切り替え: 英語/ドイツ語",
    "Switched to {mode} mode" to "{mode} モードに切り替えました",
    "System Health" to "システム健全性",
    "System Secure" to "システムセキュリティ",
    "System Status" to "システムステータス",
    "Systems Operational" to "システム稼働中",
    "TLD" to "TLD",
    "Target IP is located in a high-risk ASN." to "ターゲットIPは高リスクASNにあります。",
    "Target URL" to "ターゲットURL",
    "Technical Indicators" to "技術指標",
    "Technical Indicators:" to "技術指標:",
    "Terms" to "条件",
    "Test QR Code" to "テストQR コード",
    "Thank you! Feedback recorded: Should be {verdict}" to "ありがとうございます!記録されたフィードバック: {verdict} であるはずです",
    "The Kotlin/JS analysis engine is still loading or failed to initialize." to "Kotlin/JS 分析エンジンがまだ読み込まれているか、初期化に失敗しました。",
    "The bot was faster this time. Try again!" to "今回はボットが高速でした。もう一度お試しください!",
    "The destination URL employs" to "リンク先 URL では、",
    "The domain uses the Cyrillic 'а' (U+0430) instead of Latin 'a' (U+0061)." to "ドメインではラテン語 'a' (U+0061) ではなくキリル文字 'а' (U+0430) が使用されています。",
    "The domain uses the Cyrillic 'а' (U+0430) instead of Latin 'a' (U+0061). This technique is commonly used to trick users into believing they are visiting a legitimate service." to "ドメインではラテン語 'a' (U+0061) ではなくキリル文字 'а' (U+0430) が使用されています。この手法は、ユーザーが正規のサービスにアクセスしていると信じ込ませるためによく使用されます。",
    "The entire threat signature database (100,000+ patterns) is stored locally for millisecond lookups without any network requests." to "脅威シグネチャ データベース全体 (100,000 以上のパターン) は、ネットワーク リクエストなしでミリ秒単位で検索できるようにローカルに保存されます。",
    "The entire threat signature database is downloaded to your device for millisecond lookups." to "脅威シグネチャ データベース全体は、ミリ秒単位で検索できるようにデバイスにダウンロードされます。",
    "The image doesn\\'t contain a recognizable QR code, or it may be damaged." to "画像には認識可能な QR コードが含まれていない、または含まれている可能性があります。破損しています。",
    "The input doesn\\'t appear to be a valid URL." to "入力は有効な URL ではないようです。",
    "The number 1 and lowercase L look identical in many fonts. Always verify paypal.com directly." to "数字の 1 と小文字の L は、多くのフォントで同じに見えます。常に paypal.com を直接確認してください。",
    "The pattern matches known phishing characteristics" to "パターンは既知のフィッシングの特徴と一致します",
    "The scanned QR code contains malicious indicators associated with phishing and credential harvesting. Do not proceed to the target URL." to "スキャンされた QR コードには、フィッシングや認証情報の収集に関連する悪意のあるインジケータが含まれています。目的の URL には進まないでください。",
    "The scanned QR code shows suspicious patterns that may indicate potential security risks. Proceed with caution." to "スキャンされた QR コードには、潜在的なセキュリティ リスクを示す可能性のある疑わしいパターンが表示されます。慎重に作業を進めてください。",
    "Think you can outsmart our AI? Try to craft a phishing URL that fools the detector!" to "私たちの AI を出し抜くことができると思いますか?検出器を騙すフィッシング URL を作成してみてください。",
    "This URL passed all {count} security checks" to "この URL はすべての {count} セキュリティ チェックに合格しました",
    "This URL triggered a security check" to "この URL はセキュリティ チェックをトリガーしました",
    "This URL was flagged by Mehr Guard\\'s offline phishing detection engine." to "この URL は、Mehr Guard\\ のオフライン フィッシング検出エンジンによってフラグが付けられました。",
    "This image was analysed locally on your device. No data was sent to the cloud for this verdict." to "この画像はデバイス上でローカルに分析されました。この判決ではデータはクラウドに送信されませんでした。",
    "This is a Google subdomain - check if it\\'s the legitimate Gmail service." to "これは Google のサブドメインです - 正規の Gmail サービスかどうかを確認してください。",
    "This is a security feature — your URLs never leave your device." to "これはセキュリティ機能であり、URL がデバイスから外部に流出することはありません。",
    "This is a well-established software company domain." to "これは、確立されたソフトウェア会社のドメインです。",
    "This is the official LinkedIn domain for professional networking." to "これは、プロフェッショナル ネットワーキングのための公式 LinkedIn ドメインです。",
    "This may happen if: • You're using a very old browser • JavaScript is disabled • The page didn't fully load Try refreshing the page. If the issue persists, try Chrome, Firefox, or Safari." to "これは次の場合に発生する可能性があります。 • 非常に古いブラウザを使用している。 • JavaScript が無効になっている。 • ページが完全に読み込まれていない。 ページを更新してみてください。問題が解決しない場合は、Chrome、Firefox、または Safari を試してください。",
    "This was actually {label}." to "これは実際には {label} でした。",
    "This was {label}." to "これは{label}でした。",
    "Threat Alerts" to "脅威アラート",
    "Threat Analysis" to "脅威分析",
    "Threat Analysis Report" to "脅威分析レポート",
    "Threat Confidence" to "脅威に対する信頼性",
    "Threat Database" to "脅威データベース",
    "Threat Detected" to "脅威が検出されました",
    "Threat Verdict" to "脅威の評決",
    "Threat alerts" to "脅威アラート",
    "Threat blocked and reported" to "脅威がブロックされ、報告されました",
    "Threat database is up to date" to "脅威データベースは最新です",
    "Threat signatures updated to v2.4.1" to "脅威シグネチャが v2.4.1 に更新されました",
    "Threats" to "脅威",
    "Time" to "時間",
    "Tips for better scanning: • Ensure good lighting • Hold the camera steady • Fill the frame with the QR code • Avoid glare or reflections • Try uploading a clearer image" to "より良くスキャンするためのヒント: • 適切な照明を確保する • カメラを安定して保持する • フレームを QR コードで埋める • ぎらつきや反射を避ける • より鮮明な画像をアップロードしてみる",
    "Today, 04:00 AM" to "今日、午前 4 時",
    "Today, 14:32:05" to "今日、14:32:05",
    "Today, {time}" to "今日、{time}",
    "Toggle Judge Mode" to "ジャッジモードの切り替え",
    "Toggle Language" to "言語を切り替える",
    "Toggle Theme" to "テーマの切り替え",
    "Toggle light/dark mode" to "ライト/ダークモードの切り替え",
    "Toggle menu" to "メニューの切り替え",
    "Toggle theme" to "テーマの切り替え",
    "Top 100 Alexa Rank - whitelisted" to "トップ 100 Alexa ランク - ホワイトリストに登録",
    "Top 1k Alexa Rank whitelisted offline." to "上位 1,000 位の Alexa ランクがオフラインでホワイトリストに登録されています。",
    "Top Analysis Factors" to "上位の分析要素",
    "Torch" to "トーチ",
    "Torch error" to "トーチエラー",
    "Torch not available" to "懐中電灯は利用できません",
    "Torch off" to "トーチが消えた",
    "Torch on" to "トーチが点灯",
    "Training" to "トレーニング",
    "Training Centre" to "トレーニングセンター",
    "Trust Centre" to "トラストセンター",
    "Try Again" to "もう一度やり直してください",
    "Try It Now!" to "今すぐ試してみましょう！",
    "Typosquatting" to "タイポスクワッティング",
    "Typosquatting Detected" to "タイポスクワッティングが検出されました",
    "Typosquatting pattern detected" to "タイポスクワッティング パターンが検出されました",
    "UNKNOWN" to "未知",
    "URL" to "URL",
    "URL Shortener" to "URL短縮者",
    "URL Shortener Detected" to "URL短縮機能が検出されました",
    "URL contains Cyrillic, Greek, or other lookalike Unicode characters" to "URL にキリル文字、ギリシャ文字、またはその他の類似した Unicode 文字が含まれています",
    "URL contains another URL in query parameters" to "URL のクエリ パラメータに別の URL が含まれています",
    "URL copied to clipboard!" to "URL がクリップボードにコピーされました!",
    "URL exceeds 100 characters" to "URLが100文字を超えています",
    "URL parsing (please update your browser)" to "URL 解析 (ブラウザを更新してください)",
    "URL pasted - press Enter to analyze" to "URL が貼り付けられました - Enter キーを押して分析します",
    "URL path contains /login, /signin, /verify, /secure, /account" to "URL パスには /login、/signin、/verify、/secure、/account が含まれます",
    "URL to analyze" to "分析するURL",
    "URL uses raw IP address instead of domain name" to "URL はドメイン名の代わりに生の IP アドレスを使用します",
    "URL:" to "URL:",
    "URL: {url}" to "URL: {url}",
    "URL: {url}\\nVerdict: {verdict}\\nConfidence: {confidence}%" to "URL: {url}\\n評決: {verdict}\\n信頼度: {confidence}%",
    "URLs are risky!" to "URLは危険です！",
    "Unable to determine verdict. Please try again." to "評決を決定できません。もう一度試してください。",
    "Unknown" to "未知",
    "Unknown URL" to "不明な URL",
    "Unknown Verdict" to "不明な評決",
    "Unknown sender number" to "不明な送信者番号",
    "Unsolicited prize notification" to "未承諾の賞品通知",
    "Upload" to "アップロード",
    "Upload Image" to "画像をアップロードする",
    "Upload Image Instead" to "代わりに画像をアップロード",
    "Urgency tactics in message" to "メッセージでの緊急戦術",
    "Use condensed layout for results" to "結果に凝縮されたレイアウトを使用する",
    "Users may not notice subtle character swaps like \"1\" for \"l\" or \"0\" for \"o\"" to "ユーザーは、「1」と「l」、「0」と「o」などの微妙な文字の入れ替えに気付かない可能性があります。",
    "Uses bit.ly, t.co, tinyurl, or similar shortening service" to "bit.ly、t.co、tinyurl、または同様の短縮サービスを使用する",
    "Uses high-risk TLDs like .tk, .ml, .ga, .cf, .xyz" to ".tk、.ml、.ga、.cf、.xyz などの高リスク TLD を使用する",
    "VERIFIED SAFE" to "安全性が確認済み",
    "VS" to "VS",
    "VS MODE" to "VSモード",
    "Valid Extended Validation certificate" to "有効な拡張検証証明書",
    "Valid Google certificate" to "有効なGoogle証明書",
    "Valid SSL Certificate" to "有効なSSL証明書",
    "Verdict" to "評決",
    "Verdict: {verdict}" to "評決: {verdict}",
    "VerdictPhish" to "評決フィッシング",
    "VerdictSafe" to "評決安全",
    "VerdictWarn" to "評決警告",
    "Verified by Mehr Guard Enterprise" to "Mehr Guard エンタープライズによって検証されました",
    "Verified by Mehr Guard Enterprise v{version}" to "Mehr Guard Enterprise v{version} によって検証済み",
    "Verified by local heuristics v2.4. No phishing patterns, obfuscated scripts, or blacklist matches found." to "ローカル ヒューリスティック v2.4 によって検証済み。フィッシング パターン、難読化されたスクリプト、またはブラックリストの一致は見つかりませんでした。",
    "Verifying..." to "確認中...",
    "Version" to "バージョン",
    "Very High" to "非常に高い",
    "View All" to "すべて見る",
    "View Full History" to "全履歴を表示",
    "View Full Report" to "完全なレポートを表示",
    "View John Smith\\'s professional profile on LinkedIn." to "LinkedIn で John Smith のプロフェッショナル プロフィールをご覧ください。",
    "View Security Audit" to "セキュリティ監査の表示",
    "View detailed analysis in dashboard" to "ダッシュボードで詳細な分析を表示する",
    "Visual Appearance (What user sees)" to "見た目（ユーザーに見えるもの）",
    "WARN" to "警告",
    "Warning" to "警告",
    "We detect multiple attack types:" to "複数の種類の攻撃を検出します。",
    "We strictly disable outgoing telemetry for scans. Scan results and image hashes remain local." to "スキャンの送信テレメトリは厳密に無効になっています。スキャン結果と画像ハッシュはローカルに残ります。",
    "Welcome to Jira - project tracking for agile teams." to "Jira へようこそ - アジャイル チーム向けのプロジェクト追跡。",
    "Welcome to Mehr Guard" to "[[ブランド]] へようこそ",
    "What it checks:" to "チェック内容:",
    "Why it matters:" to "なぜそれが重要なのか:",
    "Why the bot flagged it" to "ボットがフラグを立てた理由",
    "Why this verdict?" to "なぜこの判決が出たのでしょうか？",
    "Without other risk signals, login paths on safe domains would not increase score significantly." to "他のリスク信号がなければ、安全なドメイン上のログイン パスによってスコアが大幅に増加することはありません。",
    "Works 100% offline!" to "100%オフラインでも動作します!",
    "Workspace / Security / Reports" to "ワークスペース / セキュリティ / レポート",
    "Would you like to report this URL?\\n\\nOptions:\\n1. PhishTank - Click OK to open submission page\\n2. Email - Click Cancel to compose email\\n\\nURL: {url}" to "この URL を報告しますか?\\n\\nオプション:\\n1. PhishTank - [OK] をクリックして送信ページを開きます\\n2.電子メール - [キャンセル] をクリックして電子メールを作成します\\n\\nURL: {url}",
    "Wrong Verdict?" to "間違った評決?",
    "Wrong!" to "間違っている！",
    "Yesterday" to "昨日",
    "You" to "あなた",
    "You can still use Mehr Guard by uploading images or pasting URLs directly." to "画像をアップロードするか、URL を直接貼り付けることで、Mehr Guard を引き続き使用できます。",
    "You can still use Mehr Guard: • Upload QR code images • Paste URLs directly • Use the sample URLs provided" to "Mehr Guard は引き続き使用できます。 • QR コード画像をアップロードする • URL を直接貼り付ける • 提供されているサンプル URL を使用する",
    "You correctly identified this as {label}." to "これは {label} として正しく識別されました。",
    "You have 3 unread emails in your inbox." to "受信トレイに未読メールが 3 件あります。",
    "You identified the safe URL correctly." to "安全な URL が正しく特定されました。",
    "You spotted it correctly as {label}!" to "{label} として正しく認識されました。",
    "You spotted the phishing URL correctly." to "フィッシング URL を正しく特定しました。",
    "You're offline — analysis still works!" to "オフラインです — 分析はまだ機能しています。",
    "You're reporting that this verdict may be wrong:" to "あなたはこの判決が間違っている可能性があると報告しています:",
    "You\\'re Offline" to "オフラインです",
    "Your Score" to "あなたのスコア",
    "Your browser doesn\\'t support camera access, or you\\'re on a device without a camera." to "お使いのブラウザはカメラ アクセスをサポートしていないか、カメラのないデバイスを使用しています。",
    "Your data never leaves this device. All processing is local. No tracking, no uploads." to "データがこのデバイスから出ることはありません。すべての処理はローカルで行われます。追跡もアップロードもありません。",
    "Your data stays on-device." to "データはデバイス上に残ります。",
    "\\nRisk Score:" to "\\nリスク スコア:",
    "a phishing attempt" to "フィッシングの試み",
    "actually legitimate" to "実際に合法的な",
    "bit.ly shortener" to "ちょっと短くする",
    "characters often associated with phishing campaigns targeting financial institutions. The domain age is" to "金融機関をターゲットとしたフィッシング キャンペーンに関連することが多いキャラクター。ドメインの年齢は",
    "critical" to "致命的",
    "danger" to "危険",
    "for core services." to "コアサービス向け。",
    "high" to "高い",
    "homoglyph obfuscation" to "同形文字難読化",
    "in your browser." to "ブラウザで。",
    "just now" to "ちょうど今",
    "low" to "低い",
    "malicious" to "悪意のある",
    "medium" to "中くらい",
    "offline" to "オフライン",
    "online" to "オンライン",
    "or click \"Upload\" to select a file" to "または「アップロード」をクリックしてファイルを選択します",
    "phishing" to "フィッシング",
    "risk-badge danger" to "リスクバッジの危険",
    "risk-badge warning" to "リスクバッジ警告",
    "risk-item-expanded severity-" to "リスク項目-拡大された重大度-",
    "safe" to "安全",
    "suspicious" to "疑わしい",
    "to analyze," to "分析するために、",
    "to focus," to "集中するために、",
    "to reset" to "リセットする",
    "unknown" to "未知",
    "v2.4.1 •" to "v2.4.1 •",
    "warning" to "警告",
    "without compromising data privacy." to "データのプライバシーを損なうことなく。",
    "zero-latency phishing detection" to "ゼロレイテンシーのフィッシング検出",
    "{date}, {time}" to "{date}、{time}",
    "{days} day ago" to "{days} 日前",
    "{days} days ago" to "{days} 日前",
    "{hours} hour ago" to "{hours} 時間前",
    "{hours} hours ago" to "{hours} 時間前",
    "{label} disabled" to "{label} が無効になっています",
    "{label} enabled" to "{label} 有効",
    "{level} Confidence" to "{level} 自信",
    "{minutes} minute ago" to "{minutes} 分前",
    "{minutes} minutes ago" to "{minutes} 分前",
    "{months} month ago" to "{months} 1 ヶ月前",
    "{months} months ago" to "{months} ヶ月前",
    "{points} pts" to "{points} ポイント",
    "{title}: {summary}" to "{title}: {summary}",
    "{weeks} week ago" to "{weeks} 週間前",
    "{weeks} weeks ago" to "{weeks} 週間前",
    "© 2024 Mehr Guard Security Inc. All rights reserved." to "© 2024 Mehr Guard Security Inc. 全著作権所有。",
    "हिन्दी" to "हिन्दी",
    "⌨️ Tip: Press" to "⌨️ ヒント: を押してください。",
    "⚠ Try Phishing URL" to "⚠ フィッシング URL を試してみる",
    "✅ No data leaves your device" to "✅ デバイスからデータが流出することはありません",
    "✅ Same engine as mobile apps" to "✅ モバイルアプリと同じエンジン",
    "✅ Works without internet" to "✅ インターネットなしでも動作します",
    "✓ No brand impersonation" to "✓ ブランドのなりすましはありません",
    "✓ No homograph attacks" to "✓ 同形異義語攻撃なし",
    "✓ No suspicious patterns" to "✓ 疑わしいパターンがない",
    "✓ Safe TLD" to "✓ 安全なTLD",
    "✓ Try Safe URL" to "✓ 安全な URL を試す",
    "日本語" to "日本語",
    "简体中文" to "简体中文",
    "🌐 Homograph attacks (Cyrillic chars)" to "🌐 同形文字攻撃 (キリル文字)",
    "🎉 You Win!" to "🎉 あなたの勝ちです！",
    "🎬 Demo Mode: Click \"Analyze URL\" to see detection" to "🎬 デモモード: [URL を分析] をクリックして検出を確認します。",
    "🎮 Craft a sneaky phishing URL..." to "🎮 卑劣なフィッシング URL を作成...",
    "🎮 Game Mode: Try to craft a URL that gets detected as SAFE!" to "🎮 ゲームモード: 安全であると検出される URL を作成してみてください!",
    "🏆 Players challenged:" to "🏆 挑戦したプレイヤー:",
    "🏆 You beat the bot! Score: {score}/{attempts}" to "🏆 ボットを倒しました!スコア: {score}/{attempts}",
    "💡 What would reduce this?" to "💡 これを減らすにはどうすればよいでしょうか?",
    "🔒 100% offline • Zero data collection • Open source (Apache 2.0)" to "🔒 100% オフライン • データ収集ゼロ • オープンソース (Apache 2.0)",
    "🔒 Zero data collection • 🚀 Same engine as Android & iOS • 🧠 Ensemble ML (25+ heuristics)" to "🔒 データ収集ゼロ • 🚀 Android および iOS と同じエンジン • 🧠 Ensemble ML (25 以上のヒューリスティック)",
    "🔗 URL shortener obfuscation" to "🔗 URL短縮の難読化",
    "🔤 Typosquatting (paypa1 → paypal)" to "🔤 タイポスクワッティング (paypa1 → paypal)",
    "🛡️ Mehr Guard Analysis" to "🛡️ [[ブランド]] 分析",
    "🛡️ Mehr Guard — Kotlin Multiplatform QRishing Detector" to "🛡️ Mehr Guard — Kotlin マルチプラットフォーム QRishing 検出器",
    "🤖 Bot wins! Phishing detected. Score: {score}/{attempts}" to "🤖 ボットが勝ちます!フィッシングが検出されました。スコア: {score}/{attempts}",
    "🧑‍⚖️ Demo: Forced MALICIOUS result" to "🧑‍⚖️ デモ: 強制的に MALICIOUS の結果",
    "🧑‍⚖️ Judge Mode ON - All URLs will show MALICIOUS" to "🧑‍⚖️ ジャッジ モード オン - すべての URL に MALICIOUS が表示されます",
    "🧑‍⚖️ Judge Mode activated - Demo history loaded!" to "🧑‍⚖️ ジャッジ モードが有効化 - デモ履歴が読み込まれました!",
    "🧪 Try these examples:" to "🧪 次の例を試してください:",
    "Added {date}" to "{date} に追加",
    "Analyzing..." to "解析中...",
    "Camera N/A" to "カメラ利用不可",
    "Error analyzing URL: {error}" to "URL の解析中にエラーが発生しました: {error}",
    "Challenge Mehr Guard's offline AI engine. Can you spot phishing URLs faster than the bot?" to "Mehr Guard のオフラインAIエンジンに挑戦。ボットより速くフィッシングURLを見抜けますか？",
    "Paste URL to analyze (e.g., https://example.com)" to "解析するURLを貼り付け（例: https://example.com）",
    "Mehr Guard Active Scanner - Real-time QR code scanning with AI-powered phishing detection." to "Mehr Guard アクティブスキャナー — AIによるフィッシング検知でリアルタイムQRコードスキャン。",
    "Mehr Guard Dashboard - Enterprise offline QR code security with explainable threat detection." to "Mehr Guard ダッシュボード — 企業向けオフラインQRコードセキュリティと説明可能な脅威検知。",
    "Mehr Guard Privacy Settings - 100% offline protection with zero cloud telemetry." to "Mehr Guard プライバシー設定 — 100%オフライン保護、クラウドテレメトリなし。",
    "Mehr Guard Report Export - Generate and download threat analysis reports in PDF or JSON format." to "Mehr Guard レポート書き出し — PDF または JSON 形式の脅威分析レポートを生成・ダウンロード。",
    "Mehr Guard Threat Analysis - Detailed scan result showing attack breakdown and security recommendations." to "Mehr Guard 脅威分析 — 攻撃内訳とセキュリティ推奨事項を示す詳細なスキャン結果。",
    "Mehr Guard Trust Centre - Manage privacy controls, detection sensitivity, and security lists." to "Mehr Guard トラストセンター — プライバシー管理、検出感度、セキュリティリストを管理。",
    "Mehr Guard Web - AI-powered phishing detection running entirely in your browser. Scan and analyze URLs for security threats." to "Mehr Guard Web — ブラウザ内で完全に動作するAIフィッシング検知。URLをスキャンして脅威を分析します。",
    "Mehr Guard scan results - AI-powered phishing detection with detailed security analysis." to "Mehr Guard スキャン結果 — 詳細なセキュリティ分析を備えたAIフィッシング検知。",
    "why" to "なぜ",
    "heuristics" to "ヒューリスティック",
    "redirects" to "リダイレクト",
    "ssl_issuer" to "ssl_発行者",
    "subdomain_chaining" to "サブドメイン連鎖",
    "suspicious_tld" to "疑わしい_tld",
    "threat_type" to "脅威タイプ",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "疑わしいアクティビティ",
    WebStringKey.VerdictWarning to "警告",
    WebStringKey.VerdictSuspiciousDesc to "スキャンされたQRコードは、潜在的なセキュリティリスクを示す疑わしいパターンを示しています。注意して進んでください。",
    WebStringKey.VerdictMinorConcerns to "軽微な懸念",
    WebStringKey.VerdictCaution to "注意",
    WebStringKey.VerdictMinorConcernsDesc to "いくつかの軽微なセキュリティ上の懸念が特定されました。リンクはほぼ安全に見えますが、確認をお勧めします。",
    WebStringKey.VerdictVerifiedSafe to "検証済み安全",
    WebStringKey.VerdictSafeLabel to "安全",
    WebStringKey.VerdictVerifiedSafeDesc to "セキュリティの脅威は検出されませんでした。QRコードは検証済みの安全な宛先にリンクしています。",
    WebStringKey.VerdictNoActivity to "アクティビティなし",
    WebStringKey.VerdictAwaitingScan to "スキャン待ち",
    WebStringKey.VerdictNoActivityDesc to "スキャンデータがありません。QRコードをスキャンするか、分析するURLを入力してください。",
    WebStringKey.ScanQrToSeeActivity to "QRコードをスキャンして、ここでアクティビティを確認",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "データポイント",
    WebStringKey.ProcessingEnv to "処理環境",
    WebStringKey.ExternalTransmission to "外部送信",
    WebStringKey.RawImageBuffer to "生画像バッファ",
    WebStringKey.LocalMemoryRam to "ローカルメモリ (RAM)",
    WebStringKey.TransmissionNone to "なし",
    WebStringKey.DecodedUrlPayload to "デコードされたURL/ペイロード",
    WebStringKey.LocalAnalysis to "ローカル分析",
    WebStringKey.ThreatVerdictLabel to "脅威判定",
    WebStringKey.LocalDatabase to "ローカルデータベース",
    
    // Reason Code Titles and Descriptions
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "JavaScript URL",
    WebStringKey.ReasonJavascriptUrlDesc to "JavaScript URLスキームが検出されました - クリック時にコードが実行されます",
    WebStringKey.ReasonDataUriTitle to "データURI",
    WebStringKey.ReasonDataUriDesc to "データURIスキームが検出されました - 埋め込まれた悪意のあるコードを含む可能性があります",
    WebStringKey.ReasonAtSymbolInjectionTitle to "@記号インジェクション",
    WebStringKey.ReasonAtSymbolInjectionDesc to "URLに@記号が含まれており、資格情報窃取の試みを示している可能性があります",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "ホモグラフ攻撃",
    WebStringKey.ReasonHomographDesc to "国際化ドメイン名(IDN)が別のドメインを偽装している可能性があります",
    WebStringKey.ReasonMixedScriptTitle to "混合スクリプト",
    WebStringKey.ReasonMixedScriptDesc to "ホスト名に異なるスクリプトの文字が含まれています（なりすましの可能性）",
    WebStringKey.ReasonLookalikeCharsTitle to "類似文字",
    WebStringKey.ReasonLookalikeCharsDesc to "ドメインにASCII文字に似たUnicode文字が含まれています",
    WebStringKey.ReasonZeroWidthCharsTitle to "ゼロ幅文字",
    WebStringKey.ReasonZeroWidthCharsDesc to "隠されたゼロ幅Unicode文字が検出されました（難読化の試み）",
    WebStringKey.ReasonIpHostTitle to "IPホスト",
    WebStringKey.ReasonIpHostDesc to "URLがドメイン名ではなくIPアドレスを使用しています",
    WebStringKey.ReasonCredentialParamTitle to "資格情報パラメータ",
    WebStringKey.ReasonCredentialParamDesc to "URLに資格情報関連のパラメータ（パスワード、トークンなど）が含まれています",
    WebStringKey.ReasonBrandImpersonationTitle to "ブランドなりすまし",
    WebStringKey.ReasonBrandImpersonationDesc to "URLが有名ブランドを偽装しているようです",
    WebStringKey.ReasonBrandInSubdomainTitle to "サブドメイン内のブランド",
    WebStringKey.ReasonBrandInSubdomainDesc to "ブランド名がサブドメインに表示されていますが、メインドメインには表示されていません",
    WebStringKey.ReasonRiskyExtensionTitle to "危険な拡張子",
    WebStringKey.ReasonRiskyExtensionDesc to "パスに潜在的に危険なファイル拡張子が含まれています",
    WebStringKey.ReasonDoubleExtensionTitle to "二重拡張子",
    WebStringKey.ReasonDoubleExtensionDesc to "二重のファイル拡張子が検出されました（一般的なマルウェア戦術）",
    WebStringKey.ReasonEncodedPayloadTitle to "エンコードされたペイロード",
    WebStringKey.ReasonEncodedPayloadDesc to "URLパラメータで大きなエンコードデータが検出されました",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTPでHTTPSではない",
    WebStringKey.ReasonHttpNotHttpsDesc to "URLがHTTPSではなく安全でないHTTPプロトコルを使用しています",
    WebStringKey.ReasonSuspiciousTldTitle to "疑わしいTLD",
    WebStringKey.ReasonSuspiciousTldDesc to "フィッシングによく使用されるトップレベルドメイン",
    WebStringKey.ReasonHighEntropyHostTitle to "高エントロピーホスト",
    WebStringKey.ReasonHighEntropyHostDesc to "ドメイン名がランダムに生成されたように見えます",
    WebStringKey.ReasonRedirectParamTitle to "リダイレクトパラメータ",
    WebStringKey.ReasonRedirectParamDesc to "URLに別のサイトにリダイレクトする可能性のあるパラメータが含まれています",
    WebStringKey.ReasonDeepSubdomainTitle to "深いサブドメイン",
    WebStringKey.ReasonDeepSubdomainDesc to "サブドメインの深さが過度です（実際のドメインを隠している可能性）",
    WebStringKey.ReasonMultiTldTitle to "複数のTLD",
    WebStringKey.ReasonMultiTldDesc to "ドメイン名にTLDのような複数のセグメントが含まれています",
    WebStringKey.ReasonNumericSubdomainTitle to "数字のみのサブドメイン",
    WebStringKey.ReasonNumericSubdomainDesc to "数字のみのサブドメインが検出されました",
    WebStringKey.ReasonNonStandardPortTitle to "非標準ポート",
    WebStringKey.ReasonNonStandardPortDesc to "URLが非標準のポート番号を使用しています",
    WebStringKey.ReasonSuspiciousPortTitle to "疑わしいポート",
    WebStringKey.ReasonSuspiciousPortDesc to "URLが攻撃に関連付けられることの多いポートを使用しています",
    WebStringKey.ReasonFragmentHidingTitle to "フラグメント隠蔽",
    WebStringKey.ReasonFragmentHidingDesc to "URLフラグメントが追加コンテンツを隠しているようです",
    WebStringKey.ReasonExcessiveEncodingTitle to "過度なエンコーディング",
    WebStringKey.ReasonExcessiveEncodingDesc to "過度なURLエンコーディングが検出されました（難読化の試み）",
    WebStringKey.ReasonDomainAgePatternTitle to "ドメイン年齢パターン",
    WebStringKey.ReasonDomainAgePatternDesc to "ドメイン名が自動生成ドメインのパターンと一致しています",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "URL短縮サービス",
    WebStringKey.ReasonUrlShortenerDesc to "URLが短縮サービスを使用しています（実際の宛先を隠しています）",
    WebStringKey.ReasonSuspiciousPathTitle to "疑わしいパス",
    WebStringKey.ReasonSuspiciousPathDesc to "パスに疑わしいキーワード（ログイン、確認など）が含まれています",
    WebStringKey.ReasonLongUrlTitle to "長いURL",
    WebStringKey.ReasonLongUrlDesc to "異常に長いURL",
    WebStringKey.ReasonCredentialKeywordsTitle to "資格情報キーワード",
    WebStringKey.ReasonCredentialKeywordsDesc to "URLに資格情報収集キーワードが含まれています",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "解析不能なURL",
    WebStringKey.ReasonUnparseableDesc to "URLを完全に解析できませんでした",
    WebStringKey.ReasonAnalysisCompleteTitle to "分析完了",
    WebStringKey.ReasonAnalysisCompleteDesc to "分析が正常に完了しました",
    
    // ML Score Labels
    WebStringKey.MlPhishingScore to "MLフィッシングスコア",
    WebStringKey.MlCharacterAnalysis to "文字分析",
    WebStringKey.MlFeatureAnalysis to "特徴分析",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "IDN / Punycodeドメイン",
    WebStringKey.IdnPunycodeDomainDesc to "このドメインは国際化文字を使用しています。安全な表示:",
    WebStringKey.MixedScriptAttackTitle to "混合スクリプト攻撃",
    WebStringKey.MixedScriptAttackDesc to "ドメインに複数のスクリプトの文字が含まれています（例：キリル文字 + ラテン文字）。ホモグラフ攻撃で一般的です。",
    WebStringKey.ConfusableCharsTitle to "紛らわしい文字",
    WebStringKey.ConfusableCharsDesc to "ドメインに一般的な文字に似た文字が含まれています（例：'а' vs 'a'）。"
)
